export default {
  登录: {
    rus: 'вход'
  },
  欢迎登录: {
    rus: 'Добро пожаловать'
  },
  请输入用户名: {
    rus: 'Введите имя пользователя'
  },
  '请输入密码': {
    rus: 'Введите пароль'
  },
  记住登录状态: {
    rus: 'запоминать вход'
  },
  星期一: {
    rus: 'понедельник'
  },
  智慧物联网管理平台: {
    rus: 'сетевая платформа'
  },
  设备总数: {
    rus: 'итог'
  },
  在线设备: {
    rus: 'онлайн'
  },
  今日新增: {
    rus: 'новый сегодня'
  },
  今日报警: {
    rus: 'тревога'
  },
  今日故障: {
    rus: 'неисправность'
  },
  故障: {
    rus: 'неисправность'
  },
  星期二: {
    rus: 'Вторник'
  },
  星期三: {
    rus: 'среда'
  },
  星期四: {
    rus: 'четверг'
  },
  星期五: {
    rus: 'пятница'
  },
  星期六: {
    rus: 'суббота'
  },
  星期日: {
    rus: 'воскресенье'
  },
  报警: {
    rus: 'тревога'
  },
  后台: {
    rus: 'фоновый'
  },
  退出: {
    rus: 'выход'
  },
  '请正确填写用户信息！': {
    rus: 'Заполните, пожалуйста, сообщение пользователя!'
  },
  取消: {
    rus: 'отмена'
  },
  退出登录提示: {
    rus: 'выход из списка'
  },
  '是否退出该账户?': {
    rus: 'закрыть счёт?'
  },
  设备统计: {
    rus: 'Статистика оборудования'
  },
  今日异动: {
    rus: 'асинхронный сегодня'
  },
  历史报警走势: {
    rus: 'тревожная тенденция'
  },
  最近报警: {
    rus: 'последние напоминания'
  },
  子经销商: {
    rus: 'субдилер'
  },
  报警时段分布: {
    rus: 'распределение интервалов напоминания'
  }
}

/* 
  重做
  清空
  标题
  链接
  插入图片
  添加图片链接
  上传本地图片
  插入代码块
  保存
  开启预览
  关闭预览
  目录导航
  开启目录导航
  关闭目录导航
  开启同步滚动
  关闭同步滚动
  全屏
  按ESC还原
  退出全屏
  插入提示
  提示
  提示
  在此输入内容
  注意
  注意
  在此输入内容
  警告
  警告
  在此输入内容
  详细信息
  详细信息
  内容
  正则匹配码点范围从U
  一直到U
  FFFF的文字
  补充平面Supplementary Plane
  处理码点大于U
  的文字length属性不准确的bug，如
  智慧社区
  开发过程文档存放处
  编码阶段
  个
  新路由信息
  老路由信息
  深度观察监听
  声音的音量
  语速，数值，默认值是1，范围是0
  到10
  表示说话的音高，数值，范围从0
  最小
  到2
  最大
  默认值为1
  播放语速    
  音调高低
  播放文本
  播放音量
  报警通知
  打开声音
  关闭声音
  取得浏览器的userAgent字符串
  判断是否Opera浏览器
  判断是否IE浏览器
  判断是否IE的Edge浏览器
  判断是否Firefox浏览器
  判断是否Safari浏览器
  判断Chrome浏览器
  IE版本过低
  对象内部属性的监听，关键
  基于准备好的dom，初始化echarts实例
  绘制图表
  判断当前浏览器是否支持WebSocket
  建立连接 
  线上环境
  连接发生错误的回调方法     
  连接成功建立的回调方法
  接收到消息的回调方法
  左侧菜单
  菜单赋值
  智慧星图消防物联网管理平台
  我是要执行的部分 每次点击执行一次
  菜单赋值
  设备总览
  故障历史
  单位信息
  区域管理
  角色管理
  子租户管理
  用户管理
  设备管理
  报警历史
  自查记录
  巡检点管理
  巡检模板
  巡检记录
  系统设置
  组织管理
  隐患处理记录
  隐患管理
  日志列表
  首页
  设备类型
  首页配置
  巡检类型
  巡检项
  巡检计划
  巡检统计
  巡检点
  最后一项不可关闭
  左侧菜单
  过滤菜单
  tenant为false时，即使接口有数据推送菜单项也不显示
  接口数据菜单
  过滤后的菜单
  系统管理
  无
  无
  刷新
  用户退出登录
  是否退出该账户
  退出登录提示
  退出
  取消
  退出登录成功！
  清console
  除session
  退出登录失败，请联系管理员！
  Session过期，请重新登录!
  已取消退出登录
  左侧菜单
  跳转至首页
  请输入密码
  长度在 6 到 32 个字符
  页面加载调用获取cookie值
  失焦事件
  请输入用户名
  用户名长度不能超过20个字符
  用户名长度不能少于2个字符
  用户名不合法
  记住我
  密码加密
  清空Cookie
  清空Cookie
  判断复选框是否被勾选 勾选则调用配置cookie方法
  传入账号名，密码，和保存天数3个参数
  欢迎登录！
  跳转至首页
  大屏
  首页
  请正确填写用户信息！
  设置cookie
  获取时间
  保存的天数
  字符串拼接cookie
  读取cookie
  这里显示的格式需要切割一下自己可输出看下
  再次切割
  判断查找相对应的值
  保存到保存数据的地方
  清除cookie
  修改2值都为空，天数为负1天就好了
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  星星闪动动画
  折叠导航
  关闭其他
  进入大屏
  刷新当前页面
  用户信息
  昵称
  组织
  无
  退出账号
  欢 迎 登 录
  请输入用户名
  请输入密码
  请输入验证码
  记住登录状态
  登录
  沪ICP备18020687号
  基于自主研发传感技术行业应用的物联网平台
  elementui滚动条样式 
  图片盒子 
  input框样式 
  日历 
  滚动条的滑块 
  图形类型
  图形大小，半宽
  半径
  参数，当图形为方向或菱形则总宽度为symbolSize 
  图形旋转控制
  默认取数据最小最大值
  标签文本格式器，同Tooltip
  不支持异步回调
  各异,
  各异,
  默认全局居中
  最小值
  最大值
  分割段数，默认为10
  坐标轴线
  默认显示，属性show控制显示与否
  坐标轴线
  默认显示，属性show控制显示与否
  分隔线
  默认显示，属性show控制显示与否
  属性length控制线长
  属性lineStyle
  详见lineStyle
  控制线条样式
  坐标轴小标记
  属性show控制显示与否，默认不显示
  每份split细分多少段
  属性length控制线长
  属性lineStyle控制线条样式
  单位px
  其余属性默认使用全局文本样式，详见TEXTSTYLE
  单位px
  其余属性默认使用全局文本样式，详见TEXTSTYLE
  标签文本格式器，同Tooltip
  不支持异步回调
  一级层叠
  二级层叠
  公用
  默认全局居中
  默认顺时针
  最小角度改为0
  选中时扇区偏移量
  选择模式，默认关闭，可选single，multiple
  南丁格尔玫瑰图模式，
  半径
  面积
  标签文本格式器，同Tooltip
  不支持异步回调
  默认使用全局文本样式，详见TEXTSTYLE
  当position为inner时有效，为label位置到圆心的距离与圆半径
  环状图为内外半径和
  的比例系数
  引导线两段中的第一段长度
  各异,
  兼容 2
  但是 roseType 是 area 的时候才是这样
  图形旋转控制
  各异
  默认全局居中
  默认顺时针
  最小角度改为0
  加一层containerGroup是为了clip，但是现在clip功能并没有实现
  现在没有clip功能，暂时取ec高宽
  一月
  月
  应该使用统一的空判断
  还是在list里进行空判断
  date型，支持formatter，autoformatter
  这个逻辑和getOtherAxis里一致，但是写在这里是否不好
  这里不兼容 ECharts 2
  貌似参数是整个数据
  其余属性默认使用全局文本样式，详见TEXTSTYLE
  国
  category模式也使用pieceList，但在visualMapping中不是使用pieceList
  是否改一致
  接受数组分别设定上右下左边距，同css
  值域文字颜色
  钓鱼岛
  台湾
  南海诸岛
  全国
  广东
  香港
  澳门
  北京
  天津
  一月
  二月
  三月
  四月
  五月
  六月
  七月
  八月
  九月
  十月
  十一月
  十二月
  月
  日
  一
  二
  三
  四
  五
  六
  全选
  反选
  矩形选择
  圈选
  横向选择
  纵向选择
  保持选择
  清除选择
  数据视图
  数据视图
  关闭
  刷新
  区域缩放
  区域缩放还原
  切换为折线图
  切换为柱状图
  切换为堆叠
  切换为平铺
  还原
  保存为图片
  右键另存为图片
  饼图
  柱状图
  折线图
  散点图
  涟漪散点图
  雷达图
  树图
  矩形树图
  箱型图
  K线图
  K线图
  热力图
  地图
  平行坐标图
  线图
  关系图
  桑基图
  漏斗图
  仪表盘图
  象形柱图
  主题河流图
  旭日图
  这是一个关于
  的图表
  这是一个图表，
  图表类型是
  表示
  图表类型是
  它由
  个图表系列组成
  第
  个系列是一个表示
  的
  第
  个系列是一个
  其数据是
  其中，前
  项是
  的数据是
  命令重新创建一个新的 subpath, 并且更新新的起点
  在 closePath 的时候使用
  判断的开销比较大
  旋转
  不是直接使用 arc 命令
  第一个命令起点还未定义
  使用scale来模拟椭圆, 这里也对x做一定的缩放
  公用
  自定义图
  当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系
  当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系
  为indeterminate元素 添加aria
  属性
  自定义
  enter选中
  enter选中
  click关闭
  下次tab时组件聚焦元素
  下次期望的聚焦元素
  自定义
  控制
  控制自定义元素的样式
  触发一个事件
  等
  将不在该菜单路径下的其余菜单收起
  初始化展开菜单
  展开该菜单项的路径上所有子菜单
  当radioGroup没有默认选项时，第一个可以选中Tab导航
  左右上下按键 可以在radio组内切换不同选项
  当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系
  当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系
  为indeterminate元素 添加aria
  属性
  这里的代码可以优化
  这里的代码可以优化
  不可响应的，设置 currentRowKey 时，data 不一定存在，也许无法算出正确的 currentRow
  把该值缓存一下，当用户点击修改 currentRow 时，把该值重置为 null
  为 null 时，解构时的默认值会被忽略
  当 currentRow 不在 data 中时尝试更新数据
  把初始时下设置的 rowKey 转化成 rowData
  存在于 expand
  中，这里不重复添加
  在展开行中，expandRowKeys 会被转化成 expandRows，expandRowKeys 这个属性只是记录了 TreeTable 行的展开
  拆分为独立的 TreeTable，统一用法
  嵌入型的数据，watch 无法是检测到变化 https
  使用 computed 解决该问题，是否会造成性能问题
  针对懒加载的情形，不处理嵌套数据
  当 children 不存在且 lazy 为 true，该节点即为懒加载的节点
  合并 expanded 与 display，确保数据刷新后，状态不变
  根据懒加载数据更新 treeData
  懒加载的 root 节点，更新一下原有的数据，原来的 children 一定是空数组
  版本后要求必须设置该属性
  渲染的数据来源，是对 table 中的 data 过滤排序后的结果
  是否包含固定列
  列
  不可响应的
  选择
  过滤
  不可响应的
  排序
  检查 rowKey 是否存在
  更新列
  更新 DOM
  选择
  调用 API 修改选中值，不触发 select 事件
  为 null 时，解构时的默认值会被忽略
  过滤与排序
  根据 filters 与 sort 去过滤 data
  优化这里的代码
  优化这里的代码
  适配层，expand
  在 Expand 与 TreeTable 中都有使用
  这里会触发额外的计算，但为了兼容性，暂时这么做
  展开行与 TreeTable 都要使用
  数据变化，更新部分数据
  没有使用 computed，而是手动更新部分数据 https
  修复 pr https
  导致的 bug
  判断是否text
  如果是就显示tooltip
  会引起整个 Table 的重新渲染，需要优化
  指令 v
  会覆盖 row
  中 display
  使用 
  代替 v
  表明是懒加载
  使用二维数组，避免修改 
  时，rowKey 必须由用户设定，不使用 getKeyOfRow 计算
  在调用 rowRender 函数时，仍然会计算 rowKey，不太好的操作
  渲染嵌套数据
  记录的是 index，所以还需主动增加 TreeTable 的 index
  父节点的 display 状态影响子节点的显示状态
  对于当前节点，分成有无子节点两种情况
  如果包含子节点的，设置 expanded 属性
  对于它子节点的 display 属性由它本身的 expanded 与 display 共同决定
  懒加载的某些节点，level 未知
  对于 root 节点，display 一定为 true
  是否拥有多级表头
  是有必要的 https
  使用 CSS transform
  的相关配置
  是否拥有多级表头
  这些选项不应该被覆盖
  对于特定类型的 column，某些属性不允许设置
  属性不推荐使用
  这里的实现调整
  对于展开行，renderCell 不允许配置的
  在上一步中已经设置过，这里需要简单封装一下
  对 renderCell 进行包装
  一些属性具有别名
  相关属性
  相关属性
  列
  注意 compose 中函数执行的顺序是从右到左
  注册 watcher
  也要渲染，需要计算合并表头
  忽略 time
  的该配置项
  周日为界限，左右偏移的天数，3217654 例如周一就是 
  目的是调整前两行日期的位置
  没用到
  可访问性
  tab序列
  解绑
  如果需要验证的fields为空，调用验证时立刻返回callback
  左右上下键更换tab
  改变焦点元素
  选中下一个tab
  选中
  展开
  选中
  enter选中checkbox
  取消倒计时
  esc关闭消息
  恢复倒计时
  防止在 mouseup 后立即触发 click，导致滑块有几率产生一小段位移
  不使用 preventDefault 是因为 mouseup 和 click 没有注册在同一个 DOM 上
  esc关闭消息
  极差
  失望
  一般
  满意
  惊喜
  如果 container 尺寸不会发生变化，最好设置它可以优化性能
  加载失败
  第一个月的时间范围
  下一月的时间范围，需要计算一下该月的第一个周起始日
  确定
  清空
  此刻
  今天
  取消
  清空
  确定
  选择日期
  选择时间
  开始日期
  开始时间
  结束日期
  结束时间
  前一年
  后一年
  上个月
  下个月
  年
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  周次
  日
  一
  二
  三
  四
  五
  六
  一月
  二月
  三月
  四月
  五月
  六月
  七月
  八月
  九月
  十月
  十一月
  十二月
  加载中
  无匹配数据
  无数据
  请选择
  无匹配数据
  加载中
  请选择
  暂无数据
  前往
  条
  页
  共 
  条
  页
  提示
  确定
  取消
  输入的数据不合法!
  按 delete 键可删除
  删除
  查看图片
  继续上传
  暂无数据
  筛选
  重置
  全部
  合计
  暂无数据
  无匹配数据
  无数据
  列表 1
  列表 2
  请输入搜索内容
  共 
  项
  已选 
  项
  加载失败
  返回
  确定
  取消
  暂无数据
  可访问性
  tab序列
  如果 container 尺寸不会发生变化，最好设置它可以优化性能
  触发一个事件
  等
  点击元素外面才会触发的事件
  把 YYYY
  改成了 yyyy
  中文
  令和
  平成
  昭和
  大正
  明治
  西暦
  紀元前
  元
  年
  元
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  日曜日
  月曜日
  火曜日
  水曜日
  木曜日
  金曜日
  土曜日
  日
  月
  火
  水
  木
  金
  土
  日
  月
  火
  水
  木
  金
  土
  YYYY年M月D日
  YYYY年M月D日 HH
  YYYY年M月D日 dddd HH
  YYYY年M月D日
  YYYY年M月D日 HH
  YYYY年M月D日
  午前
  午後
  午後
  午前
  午後
  今日
  明日
  来週
  昨日
  先週
  日
  元年
  年
  日
  s後
  s前
  数秒
  d秒
  分
  d分
  時間
  d時間
  日
  d日
  月
  月
  年
  d年
  数据元和交换格式
  信息交换
  日期和时间表示法
  与ISO 8601
  等效
  一月
  二月
  三月
  四月
  五月
  六月
  七月
  八月
  九月
  十月
  十一月
  十二月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  星期日
  星期一
  星期二
  星期三
  星期四
  星期五
  星期六
  周日
  周一
  周二
  周三
  周四
  周五
  周六
  日
  一
  二
  三
  四
  五
  六
  YYYY年M月D日
  YYYY年M月D日Ah点mm分
  YYYY年M月D日ddddAh点mm分
  YYYY年M月D日
  YYYY年M月D日 HH
  YYYY年M月D日dddd HH
  凌晨
  早上
  上午
  中午
  下午
  晚上
  凌晨
  早上
  上午
  下午
  晚上
  中午
  凌晨
  早上
  上午
  中午
  下午
  晚上
  今天
  明天
  下
  本
  昨天
  上
  本
  日
  月
  周
  日
  月
  周
  s后
  s前
  几秒
  秒
  分钟
  分钟
  小时
  小时
  天
  天
  周
  周
  个月
  个月
  年
  年
  数据元和交换格式
  信息交换
  日期和时间表示法
  与ISO 8601
  等效
  一月
  二月
  三月
  四月
  五月
  六月
  七月
  八月
  九月
  十月
  十一月
  十二月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  星期日
  星期一
  星期二
  星期三
  星期四
  星期五
  星期六
  週日
  週一
  週二
  週三
  週四
  週五
  週六
  日
  一
  二
  三
  四
  五
  六
  YYYY年M月D日
  YYYY年M月D日 HH
  YYYY年M月D日dddd HH
  YYYY年M月D日
  YYYY年M月D日 HH
  YYYY年M月D日dddd HH
  凌晨
  早上
  上午
  中午
  下午
  晚上
  凌晨
  早上
  上午
  中午
  下午
  晚上
  凌晨
  早上
  上午
  中午
  下午
  晚上
  今天
  明天
  下
  昨天
  上
  日
  月
  週
  日
  月
  週
  s後
  s前
  幾秒
  秒
  分鐘
  分鐘
  小時
  小時
  天
  天
  個月
  個月
  年
  年
  一月
  二月
  三月
  四月
  五月
  六月
  七月
  八月
  九月
  十月
  十一月
  十二月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  星期日
  星期一
  星期二
  星期三
  星期四
  星期五
  星期六
  週日
  週一
  週二
  週三
  週四
  週五
  週六
  日
  一
  二
  三
  四
  五
  六
  YYYY年M月D日
  YYYY年M月D日 HH
  YYYY年M月D日dddd HH
  YYYY年M月D日
  YYYY年M月D日 HH
  YYYY年M月D日dddd HH
  凌晨
  早上
  上午
  中午
  下午
  晚上
  凌晨
  早上
  上午
  中午
  下午
  晚上
  凌晨
  早上
  上午
  中午
  下午
  晚上
  今天
  明天
  下
  昨天
  上
  日
  月
  週
  日
  月
  週
  s內
  s前
  幾秒
  秒
  分鐘
  分鐘
  小時
  小時
  天
  天
  個月
  個月
  年
  年
  一月
  二月
  三月
  四月
  五月
  六月
  七月
  八月
  九月
  十月
  十一月
  十二月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  月
  星期日
  星期一
  星期二
  星期三
  星期四
  星期五
  星期六
  週日
  週一
  週二
  週三
  週四
  週五
  週六
  日
  一
  二
  三
  四
  五
  六
  YYYY年M月D日
  YYYY年M月D日 HH
  YYYY年M月D日dddd HH
  YYYY年M月D日
  YYYY年M月D日 HH
  YYYY年M月D日dddd HH
  凌晨
  早上
  上午
  中午
  下午
  晚上
  凌晨
  早上
  上午
  中午
  下午
  晚上
  凌晨
  早上
  上午
  中午
  下午
  晚上
  今天
  明天
  下
  昨天
  上
  日
  月
  週
  日
  月
  週
  s後
  s前
  幾秒
  秒
  分鐘
  分鐘
  小時
  小時
  天
  天
  個月
  個月
  年
  年
  国
  国
  星图
  设备类型
  星图
  设备类型
  副本
  副本
  副本
  副本
  副本
  副本
  副本
  副本
  副本
  副本
  副本
  副本
  副本
  副本
  上箭头 
  上箭头 
  上箭头
  上箭头
  刷新
  刷新
  双箭头
  右 
  双箭头
  右 
  双箭头
  右
  双箭头
  右
  收缩
  收缩
  缩进1
  缩进1
  星图
  设备类型
  星图
  设备类型
  星图
  设备类型
  副本
  副本
  副本
  副本
  副本
  副本
  副本
  副本
  副本
  副本
  副本
  副本
  副本
  副本
  上箭头 
  上箭头 
  上箭头
  上箭头
  刷新
  刷新
  双箭头
  右 
  双箭头
  右 
  双箭头
  右
  双箭头
  右
  收缩
  收缩
  缩进1
  缩进1
  权限判断函数
  md组件
  下面是将
  axios和
  qs挂在原型上，以便在实例中能用 this
  axios能够拿到
  导入模块
  设置语言 或 moment
  赋值使用
  登录
  首页
  全屏首页
  设备管理
  设备入库
  设备入库
  烟感设备
  燃气设备
  电气设备
  x系列燃气设备
  小工报
  一键报警
  声光报警
  雷达
  监控视频
  水压
  液压
  门磁
  网关类设备
  网关类设备
  网关类设备
  设备入库
  故障历史
  单位信息
  区域管理
  角色管理
  人员管理
  报警历史
  自查记录
  巡检类型
  巡检项
  巡检计划
  巡检点
  巡检模板
  巡检记录
  巡检统计
  隐患管理
  隐患列表
  日志管理
  子租户管理
  组织管理
  系统管理
  首页配置
  微信公众号
  微信配置信息
  微信轮播图
  区域管理
  帮助文档
  数据推送
  标签
  登录拦截
  保存当前菜单栏的路径
  保存当前点击的数据源
  保存当前点击的元数据
  保存所有数据源
  请求错误
  未授权，请重新登录
  拒绝访问
  请求出错
  请求超时
  服务器错误
  服务未实现
  网络错误
  服务不可用
  网络超时
  HTTP版本不受支持
  连接出错
  Session过期，请重新登录!
  清除session
  session过期
  清除session
  Session过期，请重新登录!
  在请求之前对data传参进行格式转换
  在请求之前对data传参进行格式转换
  登录页canvas背景
  当窗口大小改变时
  星星之间的连线
  鼠标与星星之间的连线
  生成范围在min
  max之间的随机数
  百度地图 
  监控视频 
  高德地图 
  报警通知
  新路由信息
  老路由信息
  深度观察监听
  声音的音量
  语速，数值，默认值是1，范围是0
  到10
  表示说话的音高，数值，范围从0
  最小
  到2
  最大
  默认值为1
  播放语速    
  音调高低
  播放文本
  播放音量
  报警通知
  打开声音
  关闭声音
  取得浏览器的userAgent字符串
  判断是否Opera浏览器
  判断是否IE浏览器
  判断是否IE的Edge浏览器
  判断是否Firefox浏览器
  判断是否Safari浏览器
  判断Chrome浏览器
  IE版本过低
  table兼容safari浏览器
  elementui滚动条样式 
  菜单省略号
  图片盒子 
  确认颜色样式
  进度条样式 
  input框样式 
  日历 
  form表单提交
  单选按钮样式
  下拉框样式
  input输入框focus样式
  表格滚动条的宽度
  横向滚动条
  纵向滚动条 必写
  表格滚动条的滑块
  抽屉样式
  抽屉内样式
  信息提示框
  菜单提示框
  下拉框展示
  滚动条样式
  滚动条的滑块 
  权限判断函数
  md组件
  下面是将
  axios和
  qs挂在原型上，以便在实例中能用 this
  axios能够拿到
  导入模块
  设置语言 或 moment
  赋值使用
  登录
  首页
  全屏首页
  设备管理
  设备入库
  设备入库
  烟感设备
  燃气设备
  电气设备
  x系列燃气设备
  小工报
  一键报警
  声光报警
  雷达
  监控视频
  水压
  液压
  门磁
  网关类设备
  网关类设备
  网关类设备
  设备入库
  故障历史
  单位信息
  区域管理
  角色管理
  人员管理
  报警历史
  自查记录
  巡检类型
  巡检项
  巡检计划
  巡检点
  巡检模板
  巡检记录
  巡检统计
  隐患管理
  隐患列表
  日志管理
  子租户管理
  组织管理
  系统管理
  首页配置
  微信公众号
  微信配置信息
  微信轮播图
  区域管理
  帮助文档
  数据推送
  标签
  登录拦截
  保存当前菜单栏的路径
  保存当前点击的数据源
  保存当前点击的元数据
  保存所有数据源
  未命名的渐变
  未命名的渐变
  未命名的渐变
  未命名的渐变
  未命名的渐变
  未命名的渐变
  未命名的渐变
  未命名的渐变
  未命名的渐变
  未命名的渐变
  未命名的渐变
  框
  图层
  图层 5
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  合成 3
  通知时间
  通知类型
  无
  通知结果
  成功
  成功
  成功
  失败
  失败
  失败原因
  无
  暂无数据
  注册局部过滤器
  暂无时间
  为表格内取到的后台时间
  根据报警记录查询报警通知列表
  报警内容
  处理类型
  请输入处理类型
  处理描述
  请输入处理描述
  提交中
  提交
  取 消
  误报
  真实报警
  故障
  请选择处理类型
  取消
  请按要求完善表单信息
  处理成功
  处理描述不能为空
  D环状图
  在线设备
  今日新增
  今日报警
  今日故障
  在线设备
  今日新增
  今日报警
  今日故障
  构建3d饼状图
  传入数据生成 option
  是否需要label指引线，如果要就添加一个透明的2d饼状图并调整角度使得labelLine和3d的饼状图对齐，并再次setOption
  起始角度，支持范围
  饼图的扇区是否是顺时针排布
  上述这两项配置主要是为了对齐3d的样式
  透明的空心占比
  为每一个饼图数据，生成一个 series
  配置
  使用上一次遍历时，计算出的数据和 sumValue，调用 getParametricEquation 函数，
  向每个 series
  传入不同的参数方程 series
  也就是实现每一个扇形
  通过传参设定3d饼
  环的高度，26代表26px
  准备待返回的配置项，把准备好的 legendData
  传入
  亩
  圆环的高度
  d效果可以放大
  旋转等，请自己去查看官方配置
  角度
  调整视角到主体的距离，类似调整zoom
  设置为0无法旋转
  设置为0无法缩放
  设置为0无法平移
  自动旋转
  获取3d图的最高扇区的高度
  生成扇形的曲面参数方程，用于 series
  计算
  如果只有一个扇形，则不实现选中效果
  通过扇形内径
  外径的值，换算出辅助参数 k
  默认值 1
  计算选中效果分别在 x 轴
  轴方向上的位移
  未选中，则位移均为 0
  计算高亮效果的放大比例
  未高亮，则比例为 1
  返回曲面参数方程
  幂   
  判定如果是整数，增加小数点再补0
  监听鼠标事件，实现饼图选中效果
  单选
  近似实现高亮
  放大
  效果
  监听点击事件，实现选中效果
  单选
  从 option
  中读取重新渲染扇形所需的参数，将是否选中取反
  如果之前选中过其他扇形，将其取消选中
  对 option 更新
  对当前点击的扇形，执行选中
  取消选中操作
  对 option 更新
  如果本次是选中操作，记录上次选中的扇形对应的系列号 seriesIndex
  使用更新后的 option，渲染图表
  监听 mouseover，近似实现高亮
  放大
  效果
  准备重新渲染扇形所需的参数
  如果触发 mouseover 的扇形当前已高亮，则不做操作
  否则进行高亮及必要的取消高亮操作
  如果当前有高亮的扇形，取消其高亮状态
  对 option 更新
  从 option
  中读取重新渲染扇形所需的参数，将是否高亮设置为 false
  对当前点击的扇形，执行取消高亮操作
  对 option 更新
  将此前记录的上次选中的扇形对应的系列号 seriesIndex 清空
  如果触发 mouseover 的扇形不是透明圆环，将其高亮
  对 option 更新
  从 option
  中读取重新渲染扇形所需的参数，将是否高亮设置为 true
  对当前点击的扇形，执行高亮操作
  对 option 更新
  记录上次高亮的扇形对应的系列号 seriesIndex
  使用更新后的 option，渲染图表
  修正取消高亮失败的 bug
  准备重新渲染扇形所需的参数
  从 option
  中读取重新渲染扇形所需的参数，将是否高亮设置为 true
  对当前点击的扇形，执行取消高亮操作
  对 option 更新
  将此前记录的上次选中的扇形对应的系列号 seriesIndex 清空
  使用更新后的 option，渲染图表
  启动
  创建
  绘制
  添加ticker
  浏览器
  是否是iphone
  是否是ipad
  是否是ipod
  是否是ios
  是否是android
  是否是webkit
  是否是chrome
  是否是safari
  是否是firefox
  是否是ie
  是否是opera
  定时器
  控制间隔执行
  管理所有ticker方法
  状态
  遍历执行
  舞台
  创建画布
  管理子集
  调用子集绘制
  插入
  插入子集
  子集绑定事件
  融合子集
  设置父级
  设置zIndex
  设置canvas
  添加删除方法
  插入
  绘制
  进行zIndex排序
  绘制
  清除画布
  获取事件参数
  绑定事件
  添加事件组
  绑定事件
  创建监听事件
  查询命中目标
  关闭事件
  删除事件组
  删除事件
  租户昵称
  请输入租户昵称
  租户登录名
  请输入租户登录名
  租户密码
  请输入租户登录密码
  联系电话
  请输入联系电话
  邮件地址
  请输入邮件地址
  启用预设角色
  是
  否
  通道选择
  系统区域
  租户描述
  请输入租户描述
  下一步
  上一步
  提交中
  提交
  租户登录名不能为空
  租户登录名中不能含有汉字
  租户登录名必须在20个字符以内
  该租户登录名已被占用
  请输入租户密码
  租户密码必须在6
  个字符之间
  联系电话不能为空
  您输入的号码格式不正确
  该租户联系电话已被占用
  邮箱地址不能为空
  您输入的邮箱地址格式不正确
  该租户邮箱已被占用
  租户昵称不能为空
  区域不能为空
  模块名称
  模块地址
  判断租户名称是否与本次名称相同
  树节点选中传入的值
  树节点选中传入的值
  父穿子
  添加
  微信
  短信
  电话
  API推送
  树
  树
  添加
  省市选择 
  树节点选中接收值
  树节点半选中接收值
  初始化
  获取编辑数据失败
  获取全部树id
  通道项
  通道项
  树
  树
  提交
  请正确填写相关信息！
  提交
  重置
  重置
  验证规则
  验证规则
  省市
  全
  全
  全
  中国
  全选
  全租户日志
  默认勾选的树节点 
  当前勾选的树节点
  setCheckedNodes设置目前勾选的节点，使用此方法必须设置 node
  属性，
  接收勾选节点数据的数组
  重置树节点
  关键获取所有的项目
  获取树节点总数
  获取树节点总数失败，请联系管理员
  选中传值
  全选传值
  全选传值
  全选
  全选
  全租户日志
  该功能暂未实现
  全租户日志
  地址
  点击地图事件，获取经纬度
  将得到的位置赋值给中心位置
  子组件往父组件传值
  子组件往父组件传值
  判断状态是否正确
  子组件往父组件传值
  子组件往父组件传值
  全选
  全选
  删除
  设置表格最大高度
  设置表格最大高度
  是否显示加载中
  表格数据
  可选的pageSizes
  需要展示的page的控件的数组
  表格行的类名
  表格表头的类名
  存放选中值的数组
  pageSize变化时函数
  当前页变化时函数
  多选框的选项变化是触发函数
  选中的值
  全选
  请先勾选删除内容！
  此操作将永久删除内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  右边阴影
  全选
  全选
  删除
  设置表格最大高度
  设置表格最大高度
  是否显示加载中
  表格数据
  可选的pageSizes
  需要展示的page的控件的数组
  表格行的类名
  表格表头的类名
  存放选中值的数组
  pageSize变化时函数
  当前页变化时函数
  多选框的选项变化是触发函数
  选中的值
  全选
  请先勾选删除内容！
  此操作将永久删除内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  右边阴影
  离线
  报警中
  在线
  正常
  在线
  查看
  编辑
  删除
  是否显示加载中
  可选的pageSizes
  需要展示的page的控件的数组
  pageSize变化时函数
  当前页变化时函数
  对象内部属性的监听，关键
  基于准备好的dom，初始化echarts实例
  绘制图表
  设置表格最大高度
  设置表格最大高度
  是否显示加载中
  表格数据
  可选的pageSizes
  需要展示的page的控件的数组
  表格行的类名
  表格表头的类名
  存放选中值的数组
  pageSize变化时函数
  当前页变化时函数
  多选框的选项变化是触发函数
  选中的值
  全选
  请先勾选删除内容！
  此操作将永久删除内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  暂无数据
  全选
  针对外层组件调用设计
  全选
  全不选
  针对外层组件调用设计
  返回组件状态
  已选中条目中不可编辑的keys
  允许编辑的数据
  全选
  全选
  删除
  设置表格最大高度
  设置表格最大高度
  是否显示加载中
  表格数据
  可选的pageSizes
  需要展示的page的控件的数组
  表格行的类名
  表格表头的类名
  存放选中值的数组
  pageSize变化时函数
  当前页变化时函数
  多选框的选项变化是触发函数
  选中的值
  全选
  请先勾选删除内容！
  此操作将永久删除内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  批量删除
  全部
  全部标识
  组织结构id
  设置表格最大高度
  是否显示加载中
  表格数据
  可选的pageSizes
  需要展示的page的控件的数组
  表格行的类名
  存放选中值的数组
  条
  页
  全部
  pageSize变化时函数
  当前页变化时函数
  多选框的选项变化是触发函数
  选中的值
  表格渲染全部
  登录失效，请重新登录!
  跳转至首页
  删除
  请先勾选删除内容！
  此操作将永久删除内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  改变表头样式
  改变表格数据部分样式
  改变固定栏样式
  当有操作时改变右上角样式
  单位信息
  请输入组织机构名称
  负责人姓名长度在 1 到 15 个字符
  请输入组织机构代码
  组织机构长度在 1 到 30 个字符
  查询组织机构
  节点点击发生变化时，触发事件
  传过去改变的值，监控这个值，如果发生改变，调用查询人员方法
  全选
  全选
  删除
  设置表格最大高度
  设置表格最大高度
  是否显示加载中
  表格数据
  可选的pageSizes
  需要展示的page的控件的数组
  表格行的类名
  表格表头的类名
  存放选中值的数组
  pageSize变化时函数
  当前页变化时函数
  多选框的选项变化是触发函数
  选中的值
  右边阴影
  判断当前浏览器是否支持WebSocket
  建立连接 
  线上环境
  连接发生错误的回调方法     
  连接成功建立的回调方法
  接收到消息的回调方法
  报警收到新消息
  客户端已断开连接
  基本信息
  设备名称
  是否注册
  已注册
  设备注册至
  是否安装
  是否报警
  是否故障
  是否启用
  是否在线
  通知人员类型
  通知负责人
  通知安装人
  通知安装人和负责人
  通信协议方式
  已安装
  安装位置
  已安装
  安装时间
  使用者
  使用者联系方式
  安装区域
  负责人
  联系方式
  已安装
  安装人员
  已安装
  安装人员联系方式
  入库时间
  已注册
  注册时间
  探测器类型
  探测器屏蔽标志
  探测器报警状态
  探测器故障状态
  通道1开关标志
  通道1报警标志
  通道1故障标志
  通道1类型
  通道1值
  通道1报警设定值
  通道2开关标志
  通道2报警标志
  通道2故障标志
  通道2类型
  通道2值
  通道2报警设定值
  通道3开关标志
  通道3报警标志
  通道3故障标志
  通道3类型
  通道3值
  通道3报警设定值
  通道4开关标志
  通道4报警标志
  通道4故障标志
  通道4类型
  通道4值
  通道4报警设定值
  通道5开关标志
  通道5报警标志
  通道5故障标志
  通道5类型
  通道5值
  通道5报警设定值
  通道6开关标志
  通道6报警标志
  通道6故障标志
  通道6类型
  通道7开关标志
  通道7报警标志
  通道7故障标志
  通道7类型
  通道7值
  通道7报警设定值
  通道8开关标志
  通道8报警标志
  通道8故障标志
  通道8类型
  通道8值
  通道9开关标志
  通道9报警标志
  通道9故障标志
  通道9类型
  通道9值
  通道10开关标志
  通道10报警标志
  通道10故障标志
  通道10类型
  通道10值
  通道11开关标志
  通道11报警标志
  通道11故障标志
  通道11类型
  通道11值
  断电故障标志
  A相电压报警标志
  B相电压报警标志
  C相电压报警标志
  A相电流报警标志
  B相电流报警标志
  C相电流报警标志
  相电压Va
  相电压Vb
  相电压Vc
  线电压Uab
  线电压Ubc
  线电压Uca
  相电流Ia
  相电流Ib
  相电流Ic
  A相有功功率
  B相有功功率
  C相有功功率
  A无功功率
  B无功功率
  C无功功率
  A视在功率
  B视在功率
  C视在功率
  总有功功率
  总无功功率
  总视在功率
  总电量
  电网频率
  A功率因数
  B功率因数
  C功率因数
  接线方式
  A相电压开关状态
  B相电压开关状态
  C相电压开关状态
  A相电流开关状态
  B相电流开关状态
  C相电流开关状态
  过压报警设定值
  欠压报警设定值
  A相过流设定值
  B相过流设定值
  C相过流设定值
  A相电流CT倍率
  B相电流CT倍率
  C相电流CT倍率
  BuzzerState蜂鸣器状态
  OutState输出状态
  InState输入状态
  创建时间
  更新时间
  基本信息
  设备名称
  是否注册
  已注册
  设备注册至
  是否安装
  是否报警
  是否故障
  是否启用
  是否在线
  通知人员类型
  通知负责人
  通知安装人
  通知安装人和负责人
  通信协议方式
  未知
  已安装
  安装位置
  已安装
  安装时间
  使用者
  使用者联系方式
  安装区域
  负责人
  联系方式
  已安装
  安装人员
  已安装
  安装人员联系方式
  入库时间
  信号值
  迁移值B
  迁移值K
  厂商编号
  采集间隔
  发送间隔
  波动值警告
  阈值上限
  阈值下限
  创建时间
  更新时间
  基本信息
  设备名称
  是否注册
  已注册
  设备注册至
  是否安装
  是否报警
  是否故障
  是否启用
  是否在线
  通知人员类型
  通知负责人
  通知安装人
  通知安装人和负责人
  通信协议方式
  已安装
  安装位置
  已安装
  安装时间
  使用者
  使用者联系方式
  已安装
  安装人员
  已安装
  安装人员联系方式
  入库时间
  已注册
  注册时间
  硬件版本号
  软件版本
  厂商编号
  开关数量
  串口数量
  信号强度
  通讯类型
  基本信息
  设备名称
  设备ID
  设备注册至
  祥云
  联通
  电信
  祥云设备ID
  祥云设备标识
  联通设备ID
  联通设备Key
  是否注册
  已注册
  未注册
  注册失败
  是否安装
  已安装
  未安装
  是否报警
  报警
  未报警
  是否故障
  已故障
  未故障
  是否启用
  已启用
  未启用
  是否在线
  在线
  离线
  通知人员类型
  通知负责人
  通知安装人
  通知安装人和负责人
  通信协议方式
  未知
  启用方式
  启用
  禁用
  安装位置
  入库时间
  注册时间
  安装时间
  使用者
  使用者联系方式
  安装区域
  负责人
  联系方式
  安装人员
  安装人员联系方式
  设备类型名称
  设备种类
  基本信息
  设备名称
  设备编码
  设备类型
  参数配置
  报警上限
  报警上限
  报警下限
  报警下限
  配置
  保存中
  保存
  当前状态
  当前漏电流
  当前压力值
  当前状态
  当前电压
  a相温度
  b相温度
  c相温度
  当前液位值
  报警下限不能为空
  报警上限不能为空
  data个数代表波浪数
  画中间的图标
  解决圆点过大后续部分显示明显的问题
  画剩余的刻度圆环
  温度计 edge
  温度计 edge
  温度计 edge
  刻度
  刻度数量
  仪表盘轴线
  刻度标签
  刻度样式
  分隔线样式
  坐标轴小标记
  坐标轴小标记
  属性length控制线长
  属性lineStyle控制线条样式
  指针颜色
  其余属性默认使用全局文本样式，详见TEXTSTYLE
  坐标轴小标记
  坐标轴小标记
  属性length控制线长
  属性lineStyle控制线条样式
  其余属性默认使用全局文本样式，详见TEXTSTYLE
  坐标轴小标记
  坐标轴小标记
  属性length控制线长
  属性lineStyle控制线条样式
  其余属性默认使用全局文本样式，详见TEXTSTYLE
  近7日液位走势
  液位值
  近7日水压走势
  压力值
  正常
  燃气泄漏
  请按要求完善表单信息
  参数配置成功
  设备名称
  请输入设备名称
  设备编码
  请输入设备编码
  设备类型
  请选择设备类型
  安装区域
  请选择安装区域
  安装位置
  请输入安装位置
  关联摄像
  请选择摄像头
  备注信息
  提交中
  提交
  取 消
  添加
  请选择设备类型
  请选择安装区域
  区域管理
  设备类型
  摄像头
  取消
  确认
  请按要求完善表单信息
  设备添加成功
  设备编辑成功
  设备名不能为空
  设备名长度不能超过20个字符
  设备名长度不能少于1个字符
  设备名不合法,请输入由
  或字母或汉字或数字组成！
  编码不能为空
  编码长度必须为12个字符
  编码长度必须为12个字符
  编码不合法,请输入由英文
  或数字组成的编码！
  安装位置不能为空
  安装位置长度不能超过20个字符
  安装位置长度不能少于1个字符
  安装位置不合法,请输入由
  或字母或汉字或数字组成！
  下载模板
  异常记录
  组织机构
  无匹配项
  暂无数据
  清除
  请选择组织机构
  通知人员类型
  请选择报警和故障通知人员类型
  上传文件
  将文件拖到此处，或
  点击上传
  只能上传xlsx
  xls文件，且不超过10M
  设备名称
  请输入设备名称
  设备编码
  请输入设备编码
  心跳间隔
  请输入设备心跳间隔
  设备类型
  请选择设备类型
  组织机构
  无匹配项
  暂无数据
  清除
  请选择组织机构
  无匹配项
  暂无数据
  清除
  请选择组织机构
  是否启用
  请选择启用方式
  通知人员类型
  请选择报警和故障通知人员类型
  通信类型
  请选择通信类型
  协议类型
  请选择协议类型
  请输入设备IMEI号
  推送地址
  请输入推送地址
  请输入设备CCID
  NB工作模式
  请选择NB工作模式
  运营商
  请选择所属运营商
  请输入设备IMSI号
  SIM卡周期
  至
  开始日期
  结束日期
  设备周期
  至
  开始日期
  结束日期
  提交中
  提交
  取 消
  上传excell时，同时允许上传的最大数
  excel文件列表
  添加
  禁用
  启用
  通知负责人
  通知安装人
  通知安装人和负责人
  汉威通用协议
  私有协议
  完全透传
  电信
  联通
  华为
  电信ctwing
  设备类型为必填项
  组织机构为必填项
  通知人员类型为必填项
  请选择协议类型
  请选择协议类型
  请选择工作模式
  请选择运营商
  编辑
  取消
  确认
  用户必须上传文件!
  请按要求完善表单信息
  设备添加成功
  设备信息修改成功
  异常记录
  条,请点击异常记录进行下载查看！
  提交成功
  请点击异常记录进行下载查看！
  文件超出个数限制时的钩子
  只能上传 
  个文件，当前共选择了 
  个
  只能上传 
  个文件
  文件状态改变时的钩子
  上传模板只能是 xls
  xlsx格式!
  文件大小不得超过10M
  上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
  上传模板只能是 xls
  xlsx格式!
  文件大小不得超过10M
  文件上传成功时的钩子
  文件上传成功
  文件上传失败时的钩子
  文件上传失败
  因为action参数是必填项，我们使用二次确认进行文件上传时，直接填上传文件的url会因为没有参数导致api报404，所以这里将action设置为一个返回为空的方法就行，避免抛错
  请上传文件
  验证规则
  设备名称为必填项
  名称长度不能超过20个字符
  名称长度不能少于2个字符
  名称不合法,设备名称中不能包含特殊符号！
  编码不能为空
  编码长度必须为12个字符
  编码长度必须为12个字符
  编码不合法,请输入由英文
  或数字组成的编码！
  心跳间隔不能为空
  心跳间隔时间长度不能超过6个字符
  心跳间隔格式不合法,请输入正整数作为心跳间隔时间！
  IMEI为必填项
  IMEI长度必须是15个字符
  IMEI长度必须是15个字符
  IMEI不合法,请输入由数字字母组成的IMEI！
  IMSI不能为空
  IMSI长度不能超过15个字符
  IMSI不合法,请输入由数字组成的IMSI！
  CCID不能为空
  CCID长度必须为20个字符
  CCID长度必须为20个字符
  CCID不合法,请输入由英文字符或数字组成的CCID！
  转换时间
  暂无时间
  为表格内取到的后台时间
  异常记录
  无异常记录
  下载excel模板
  树形结构
  去掉children
  null的属性
  设备信息
  请输入设备名称
  使用人
  请选择使用人
  安装位置
  请输入设备编码
  确认
  取 消
  郑州市
  请选择设备类型
  请选择安装区域
  设备Id
  安装时间
  无
  设备名称
  租户Id
  取消
  设备名不能为空
  设备名长度不能超过20个字符
  设备名长度不能少于1个字符
  设备名不合法,请输入由
  或字母或汉字或数字组成！
  编码不能为空
  编码长度必须为12个字符
  编码长度必须为12个字符
  编码不合法,请输入由英文
  或数字组成的编码！
  安装位置不能为空
  安装位置长度不能超过20个字符
  安装位置长度不能少于1个字符
  安装位置不合法,请输入由
  或字母或汉字或数字组成！
  地图
  操作类型
  安装
  拆卸
  是否租户操作
  是
  否
  操作者
  安装位置
  操作时间
  使用时长
  取消
  表格当前页变化时
  表格展示条数变化时
  基本信息
  设备名称
  是否注册
  已注册
  设备注册至
  是否安装
  是否报警
  是否故障
  是否启用
  是否在线
  通知人员类型
  通知负责人
  通知安装人
  通知安装人和负责人
  通信协议方式
  已安装
  安装位置
  已安装
  安装时间
  使用者
  使用者联系方式
  安装区域
  负责人
  联系方式
  已安装
  安装人员
  已安装
  安装人员联系方式
  入库时间
  已注册
  注册时间
  硬件版本号
  软件版本
  厂商编号
  主板电量
  通讯板电量
  信号覆盖等级
  设备类型代码
  模组类型
  无线模组信号值
  信号接收功率
  信噪比
  温度信号值
  基本信息
  设备类型名称
  设备注册至
  祥云
  联通
  设备心跳周期
  设备报警时间间隔
  通信协议方式
  启用方式
  启用
  禁用
  创建时间
  设备类型名称
  请输入设备名称
  设备注册至
  请选择设备注册至
  设备心跳周期
  请输入设备心跳周期
  设备报警时间间隔
  请输入设备报警时间间隔
  通信协议方式
  请选择通信协议方式
  是否启用
  请选择启用方式
  上传文件
  将文件拖到此处，或
  点击上传
  只能上传xlsx
  xls文件，且不超过10M
  提交中
  提交
  取 消
  上传excell时，同时允许上传的最大数
  excel文件列表
  添加
  启用
  禁用
  祥云
  联通
  请选择设备注册到
  请选择通信协议方式
  请选择启用方式
  取消
  确认
  请按要求完善表单信息
  设备类型添加成功
  设备类型编辑成功
  文件超出个数限制时的钩子
  只能上传 
  个文件，当前共选择了 
  个
  只能上传 
  个文件
  文件状态改变时的钩子
  上传模板只能是 xls
  xlsx格式!
  文件大小不得超过10M
  上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
  上传模板只能是 xls
  xlsx格式!
  文件大小不得超过10M
  文件上传成功时的钩子
  文件上传成功
  文件上传失败时的钩子
  文件上传失败
  因为action参数是必填项，我们使用二次确认进行文件上传时，直接填上传文件的url会因为没有参数导致api报404，所以这里将action设置为一个返回为空的方法就行，避免抛错
  请上传文件
  设备类型名称不能为空
  设备类型名称长度不能超过32个字符
  设备类型名称长度不能少于2个字符
  设备类型名称不合法,请输入由
  或字母或汉字或数字组成！
  编码不能为空
  编码长度必须为12个字符
  编码长度必须为12个字符
  编码不合法,请输入由英文
  或数字组成的编码！
  安装位置不能为空
  安装位置长度不能超过20个字符
  安装位置长度不能少于1个字符
  安装位置不合法,请输入由
  或字母或汉字或数字组成！
  通知时间
  通知类型
  无
  通知结果
  成功
  成功
  成功
  失败
  失败
  失败原因
  无
  暂无数据
  注册局部过滤器
  暂无时间
  为表格内取到的后台时间
  根据报警记录查询报警通知列表
  故障内容
  处理类型
  请输入处理类型
  处理描述
  请输入处理描述
  提交中
  提交
  取 消
  报废
  维修中
  已完成
  撤销
  请选择处理类型
  取消
  请按要求完善表单信息
  处理成功
  处理描述不能为空
  设备量走势
  设备量走势 
  暂无设备量走势
  处的颜色
  处的颜色
  缺省为 false
  数据自动刷新，必然需要一个监听机制告诉Echarts重新设置数据
  观察option的变化
  对象内部属性的监听，关键
  模拟数据
  电气火灾设备
  电气火灾设备
  电气火灾设备
  电气火灾设备
  电气火灾设备
  电气火灾设备
  电气火灾设备
  电气火灾设备
  处理异常情况
  没有找到您要查询的相关数据
  没有找到您要查询的相关数据
  解析数据
  总量
  无线烟感
  无线感温
  电气火灾控制器
  无线可燃气体
  交谈服务
  康复服务
  助行服务
  不满意度
  没有找到您要查询的相关数据
  图例组件
  图例项的 icon
  提供的标记类型包括 
  也可以通过 
  设置为图片，其中 url 为图片的链接，或者 dataURI
  可以通过 
  将图标设置为任意的矢量路径
  图例距离顶部边距
  图例距离左侧边距
  图例标记的图形宽度
  图例标记的图形高度
  图例每项之间的间隔
  横向布局时为水平间隔，纵向布局时为纵向间隔
  图例列表的布局朝向,
  为横向,
  为纵向
  图例的公用文本样式
  图例的数据数组
  数组项通常为一个字符串，每一项代表一个系列的 name
  如果是饼图，也可以是饼图单个数据的 name
  图例组件会自动根据对应系列的图形标记
  来绘制自己的颜色和标记，特殊字符串 
  空字符串
  或者 
  换行字符串
  用于图例的换行
  图例项的名称，应等于某系列的name值
  如果是饼图，也可以是饼图单个数据的 name
  图例项的 icon
  图例项的文本样式
  文字字体的粗细，可选
  圆中心坐标，数组的第一项是横坐标，第二项是纵坐标
  圆的半径，数组的第一项是内半径，第二项是外半径
  n增
  数据自动刷新，必然需要一个监听机制告诉Echarts重新设置数据
  观察option的变化
  对象内部属性的监听，关键
  基于准备好的dom，初始化echarts实例
  没有找到您要查询的相关数据
  大屏头部 
  报警
  后台
  后台
  退出
  退出
  后台
  中间统计数据 
  地图 
  左侧卡片 
  右侧卡片 
  地图
  图层切换 
  地图
  信息窗体 
  管理方
  安装位置
  安装时间
  注册时间
  创建时间
  报警弹框 
  报警通知
  报警内容
  报警位置
  设备总数
  在线设备
  今日新增
  今日报警
  今日故障
  管理方
  稷东派出所烟感
  安装位置
  加薪服饰
  地址
  加薪服饰
  安装时间
  开卡时间
  结卡时间
  信息窗体对象
  卫星
  地图
  初始化信息请求
  获取左右卡片列表
  地图中间顶部统计数据
  安前宾让去掉 2022
  风险
  session会过期 
  获取系统设置信息
  顶部左上角时间信息
  顶部左上角时间信息
  日
  一
  二
  三
  四
  五
  六
  年
  月
  日
  星期
  地图中间顶部统计数据
  获取左右卡片列表
  获取系统设置信息
  未知     
  获取系统名称
  获取系统区域
  获取首页配置信息
  卫星图
  获取中心坐标及城市
  获取地图扎点
  获取marker成功
  获取marker失败
  获取marker失败
  将获取的地图扎点渲染在初始化好的地图上
  朱的设备
  河南省郑州市中原区牡丹路办公室
  调用iot失败
  祥云烟感YB035
  无负责人
  测试租户
  勿删
  莲花街
  空开测试2号
  请求参数不合法
  联通智能空开
  无负责人
  测试租户
  勿删
  地方官员111
  空开测试2号
  请求参数不合法
  联通智能空开
  无负责人
  测试租户
  勿删
  地方官员111
  智能空开编号1
  产品不存在
  联通智能空开
  无负责人
  测试租户
  勿删
  地方官员111
  智能空开编号2
  产品不存在
  联通智能空开
  无负责人
  测试租户
  勿删
  地方官员111
  智能空开03
  产品不存在
  联通智能空开
  无负责人
  测试租户
  勿删
  地方官员111
  空开0209
  产品不存在
  联通智能空开
  无负责人
  测试租户
  勿删
  地方官员111
  空开0209
  产品不存在
  联通智能空开
  无负责人
  测试租户
  勿删
  地方官员111
  空开0209
  产品不存在
  联通智能空开
  无负责人
  测试租户
  勿删
  地方官员111
  空开0209
  产品不存在
  联通智能空开
  无负责人
  测试租户
  勿删
  地方官员111
  空开0209
  产品不存在
  联通智能空开
  无负责人
  测试租户
  勿删
  地方官员111
  重复开始
  朱的设备
  河南省郑州市中原区牡丹路办公室
  调用iot失败
  祥云烟感YB035
  无负责人
  测试租户
  勿删
  莲花街
  空开测试2号
  请求参数不合法
  联通智能空开
  无负责人
  测试租户
  勿删
  地方官员111
  空开测试2号
  请求参数不合法
  联通智能空开
  无负责人
  测试租户
  勿删
  地方官员111
  智能空开编号1
  产品不存在
  联通智能空开
  无负责人
  测试租户
  勿删
  地方官员111
  智能空开编号2
  产品不存在
  联通智能空开
  无负责人
  测试租户
  勿删
  地方官员111
  智能空开03
  产品不存在
  联通智能空开
  无负责人
  测试租户
  勿删
  地方官员111
  空开0209
  产品不存在
  联通智能空开
  无负责人
  测试租户
  勿删
  地方官员111
  空开0209
  产品不存在
  联通智能空开
  无负责人
  测试租户
  勿删
  地方官员111
  空开0209
  产品不存在
  联通智能空开
  无负责人
  测试租户
  勿删
  地方官员111
  空开0209
  产品不存在
  联通智能空开
  无负责人
  测试租户
  勿删
  地方官员111
  空开0209
  产品不存在
  联通智能空开
  无负责人
  测试租户
  勿删
  地方官员111
  烟雾
  可燃气体
  井盖
  电气火灾
  气体
  液位
  水压
  金安门磁
  声光
  空开
  英吉森小工报
  切换地图图层
  信息弹窗
  infoWindow对象
  关闭信息窗口
  地图
  获取行政区域
  网上查了下，东西经南北纬的范围
  东北角
  西北角
  西南角
  东南角
  添加环形遮罩层
  中国
  建立多边形覆盖物
  给目标行政区划添加边框，其实就是给目标行政区划添加一个没有填充物的遮罩层
  调整视野
  区域
  烟感
  指定定位位置
  设置图片偏移
  指定定位位置
  设置图片偏移
  可燃气体
  指定定位位置
  设置图片偏移
  指定定位位置
  设置图片偏移
  其他离线
  指定定位位置
  设置图片偏移
  指定定位位置
  设置图片偏移
  创建信息窗口对象
  信息窗口宽度
  信息窗口高度
  设置允许信息窗发送短息
  管理方
  安装位置
  安装时间
  注册时间
  创建时间
  开启信息窗口
  点聚合
  初始化地图
  画边缘线
  初始化地图成功
  外多边形坐标数组和内多边形坐标数组
  假装描边
  省市区地图
  利用行政区查询获取边界构建mask路径
  初始化地图
  获取首页配置信息
  地图图层工具
  添加高度面
  添加描边
  初始化地图成功
  退出
  是否退出该账户
  退出登录提示
  退出
  取消
  退出登录成功！
  退出登录失败，请联系管理员！
  Session过期，请重新登录!
  已取消退出登录
  Echarts大屏
  长连接
  心跳检测
  s发一次心跳
  这里发送一个心跳，后端收到后，返回一个心跳消息，
  onmessage拿到返回的心跳就说明连接正常
  如果超过一定时间还没重置，说明后端主动断开了
  如果onclose会执行reconnect，我们执行ws
  就行了
  如果直接执行reconnect 会触发onclose导致重连两次
  websocket通信失败!
  心跳检测重置
  开始
  结束
  心跳检测重置
  解析数据
  保证只展示四条报警弹框
  播报语音
  判断用户的系统
  系统
  关闭某个报警弹窗
  打开某个报警弹窗
  没有坐标哦！
  显示弹框内容
  检测当前浏览器
  取得浏览器的userAgent字符串
  判断是否Opera浏览器
  判断是否IE浏览器
  判断是否IE的Edge浏览器
  判断是否Firefox浏览器
  判断是否Safari浏览器
  判断Chrome浏览器
  IE版本过低
  前缀
  确认关闭
  今日异动
  今日异动 
  报警 
  报警
  故障 
  故障
  渲染的容器
  今日异动
  百分比计算方式1格
  格
  格
  报警数据解析
  故障数据解析
  设备分类
  设备分类 
  设备类型个数 
  设备类型
  外环装饰，没有实际含义
  设备分类
  内环装饰，没有实际含义
  无线烟感 1
  无线烟感 2
  电气火灾控制器
  无线可燃气体
  占比
  占比
  个
  设备统计
  设备统计 
  设备统计
  数据请求
  烟雾
  可燃气体
  井盖
  电气火灾
  气体
  液位
  水压
  金安门磁
  声光
  空开
  英吉森小工报
  设备统计
  轮播
  为实现无缝滚动，需要复制一份数据衔接一下
  历史报警走势
  历史报警走势 
  基于准备好的dom，初始化echarts实例
  绘制图表，this
  option是数据
  没有找到您要查询的相关数据
  最新报警
  最新报警 
  设备
  状态
  已处理
  未处理
  地址
  分钟内无报警
  数据请求
  请求数据后，在做轮播效果
  为实现无缝滚动，需要复制一份数据衔接一下
  子经销商
  子经销商 
  一级经销商
  二级经销商
  其他
  一级经销商
  二级经销商
  其他
  按照之前的逻辑，取三个数的最大值为满值
  计算各个数值占最大值的比
  报警时段
  报警时段 
  时间
  小时
  个数
  时间
  小时
  日期
  个数
  多线图
  报警
  故障
  报警
  是否平滑
  故障
  是否平滑
  数据自动刷新，必然需要一个监听机制告诉Echarts重新设置数据
  观察option的变化
  对象内部属性的监听，关键
  表示当前时间
  基于准备好的dom，初始化echarts实例
  绘制图表，this
  option是数据
  多线图
  报警
  故障
  报警
  是否平滑
  故障
  是否平滑
  数据自动刷新，必然需要一个监听机制告诉Echarts重新设置数据
  观察option的变化
  对象内部属性的监听，关键
  基于准备好的dom，初始化echarts实例
  绘制图表，this
  option是数据
  多线图
  报警
  故障
  报警
  是否平滑
  故障
  是否平滑
  数据自动刷新，必然需要一个监听机制告诉Echarts重新设置数据
  观察option的变化
  对象内部属性的监听，关键
  表示当前时间
  基于准备好的dom，初始化echarts实例
  绘制图表，this
  option是数据
  隐患标题
  请输入隐患标题
  隐患位置
  隐患描述
  隐患风险等级
  低风险
  中风险
  高风险
  隐患现场图片
  提交中
  提交
  取 消
  展示单个图片
  隐患标题不能为空
  隐患标题大于1个字符
  隐患标题小于50个字符
  隐患位置不能为空
  隐患位置长度不能超过500个字符
  隐患位置长度不能少于1个字符
  取消
  请按要求完善表单信息
  隐患上报成功
  新增隐患现场图片上传成功
  对上传图片的大小
  格式进行限制
  只支持jpeg或jpg或png格式图片
  请上传1MB以内的图片!
  基本信息
  隐患标题
  现场情况
  整改意见
  处理结果
  处理图片
  处理人
  处理时间
  签名
  图片放大
  隐患标题
  请输入隐患名称
  处理时间
  选择日期时间
  现场情况
  整改意见
  处理结果
  处理图片
  隐患处理签名
  签名
  签名
  确定
  清除
  提交中
  提交
  取 消
  是否正在绘制中且移动
  展示单个图片
  添加
  现场情况
  整改意见
  处理结果
  隐患处理照片原图
  隐患处理签名照片
  请选择隐患类型
  请选择安装区域
  获取DOM
  设置画布宽
  设置画布高
  二维绘图
  颜色
  线条宽度
  取消
  确认
  绘画转图片
  处理结果
  现场情况
  整改意见
  请按要求完善表单信息
  请确定签名
  隐患处理成功
  对上传图片的大小
  格式进行限制
  只支持jpeg或jpg或png格式图片
  请上传1MB以内的图片!
  隐患名不能为空
  隐患名长度不能超过20个字符
  隐患名长度不能少于1个字符
  隐患名不合法,请输入由
  或字母或汉字或数字组成！
  处理结果不能为空
  处理结果大于1个字符
  处理结果小于500个字符
  安装位置不能为空
  安装位置长度不能超过20个字符
  安装位置长度不能少于1个字符
  安装位置不合法,请输入由
  或字母或汉字或数字组成！
  鼠标按下
  开始
  获取鼠标在画板
  的坐标
  鼠标移动
  移动中
  获取鼠标在画板
  的坐标
  把路径移动到画布中的指定点，不创建线条
  起始点
  添加一个新点，然后创建从该点到画布中最后指定点的线条，不创建线条
  绘制
  重置点坐标为上一个坐标
  鼠标松开
  结束
  停止绘制
  关闭绘制开关
  绘画转图片
  请先进行签名
  颜色
  折叠导航
  左侧菜单
  菜单赋值
  智慧星图消防物联网管理平台
  我是要执行的部分 每次点击执行一次
  菜单赋值
  关闭其他
  设备总览
  故障历史
  单位信息
  区域管理
  角色管理
  子租户管理
  用户管理
  设备管理
  报警历史
  自查记录
  巡检点管理
  巡检模板
  巡检记录
  系统设置
  组织管理
  隐患处理记录
  隐患管理
  日志列表
  首页
  设备类型
  首页配置
  巡检类型
  巡检项
  巡检计划
  巡检统计
  巡检点
  最后一项不可关闭
  左侧菜单
  过滤菜单
  tenant为false时，即使接口有数据推送菜单项也不显示
  接口数据菜单
  过滤后的菜单
  系统管理
  进入大屏
  刷新当前页面
  用户信息
  昵称
  组织
  无
  退出账号
  退出
  无
  无
  刷新
  用户退出登录
  是否退出该账户
  退出登录提示
  退出
  取消
  退出登录成功！
  清console
  除session
  退出登录失败，请联系管理员！
  Session过期，请重新登录!
  已取消退出登录
  左侧菜单
  跳转至首页
  请输入用户名
  请输入密码
  请输入验证码
  记住登录状态
  登录
  请输入密码
  长度在 6 到 32 个字符
  页面加载调用获取cookie值
  失焦事件
  请输入用户名
  用户名长度不能超过20个字符
  用户名长度不能少于2个字符
  用户名不合法
  记住我
  密码加密
  清空Cookie
  清空Cookie
  判断复选框是否被勾选 勾选则调用配置cookie方法
  传入账号名，密码，和保存天数3个参数
  欢迎登录！
  跳转至首页
  请正确填写用户信息！
  设置cookie
  获取时间
  保存的天数
  字符串拼接cookie
  读取cookie
  这里显示的格式需要切割一下自己可输出看下
  再次切割
  判断查找相对应的值
  保存到保存数据的地方
  清除cookie
  修改2值都为空，天数为负1天就好了
  欢 迎 登 录
  请输入用户名
  请输入密码
  请输入验证码
  记住登录状态
  登录
  请输入密码
  长度在 6 到 32 个字符
  页面加载调用获取cookie值
  失焦事件
  请输入用户名
  用户名长度不能超过20个字符
  用户名长度不能少于2个字符
  用户名不合法
  记住我
  密码加密
  清空Cookie
  清空Cookie
  判断复选框是否被勾选 勾选则调用配置cookie方法
  传入账号名，密码，和保存天数3个参数
  欢迎登录！
  跳转至首页
  大屏
  首页
  请正确填写用户信息！
  设置cookie
  获取时间
  保存的天数
  字符串拼接cookie
  读取cookie
  这里显示的格式需要切割一下自己可输出看下
  再次切割
  判断查找相对应的值
  保存到保存数据的地方
  清除cookie
  修改2值都为空，天数为负1天就好了
  这里使用的是 2
  语法，对于新项目请使用 2
  语法
  巡检人
  巡检模板名称
  巡检计划状态
  未开始
  进行中
  已结束
  巡检日期
  巡查计划详情
  新增
  已结束
  进行中
  未开始
  巡检人员
  巡检模板名称
  已结束
  进行中
  未开始
  巡检人员
  巡检模板名称
  已结束
  进行中
  未开始
  巡检人员
  巡检模板名称
  错误提示的文案
  文字说明文字说明文字说明文字说明文字说明文字说明
  暂无数据
  点击前一个月
  上一月
  上个月头天
  点击下一个月
  下一月
  下个月头天
  点击今天
  今天
  今天
  当天巡检详细数据
  鼠标悬浮通过时间获取当天所有的巡检状态
  点击日期块
  日历块点击
  点击信息块
  新增排班
  删除排班
  此操作将永久删除该排班, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  巡查区域
  请选择巡查区域
  巡查项
  自定义项
  提交中
  提交
  取 消
  巡查区域不能为空
  添加节点
  请输入自定义巡查项目信息
  删除节点
  获取区域
  初始化巡查树
  初始化树
  初始化树
  编辑时，marge数据库选择项
  编辑时，加载数据库中的巡查内容
  树节点key 
  巡查项 
  巡查内容
  取消
  确认
  把二级节点巡查设备信息赋值给三级节点巡查内容
  校验自定义巡查项目下是否添加巡查内容
  校验是否存在为空的巡查项
  请输入巡查项内容
  校验是否选择巡查内容
  请选择计划巡查的内容
  校验是否存在相同的巡查项目
  存在相同的巡查项目
  校验是否存在相同的巡查内容
  存在相同的巡查内容
  校验自定义巡查项目下是否添加巡查内容
  请在巡查项目下添加巡查内容
  巡查内容
  请按要求完善表单信息
  巡查点保存成功
  名称校验
  巡查项目不能为空
  巡查项目长度不能超过20个字符
  巡查项目名长度不能少于1个字符
  巡查项目不合法,请输入由
  或英文字符或数字组成的用户名！
  加载树
  遍历json对象的每个key
  value对,p为key
  自定义项
  添加自定义根节点
  自定义项
  初始化树节点
  巡查设备类别
  一级节点
  自定义项
  巡查设备
  二级节点
  自定义项
  巡查内容
  三级节点
  判断数组中是否存在相同元素
  巡检设备类型
  请选择父项类型
  请选择子项类型
  巡检设备类型
  无匹配项
  暂无数据
  请选择巡检设备类型
  巡检项名称
  请输入巡检项名称
  巡检项内容
  请输入巡检项内容
  巡检项内容
  提交中
  提交
  取 消
  巡检设备类型不能为空
  页面数据校验
  巡检项名称不能为空
  巡检项名称长度不能超过20个字符
  页面初始化
  初始化
  巡查设备类型
  下拉列表
  获取树结构巡检设备类型
  获取父级设备类型
  暂无数据
  子项类型暂无数据，请重新选择父项类型
  子项类型存在，请进行选择
  取消
  确认
  请填写巡检项名称
  请选择巡检设备类型
  树形结构
  去掉children
  null的属性
  巡检模板
  请选择巡检模板
  巡检时间
  选择日期时间
  巡检人
  请选择巡检模板
  提交中
  提交
  取 消
  如果没有后面的
  就是不可以选择今天的 
  巡检模板不能为空
  巡检时间不能为空
  巡检人不能为空
  templatePageList获取模板列表
  获取巡检人列表
  页面数据校验
  巡检计划名称不能为空
  巡检计划名称长度不能超过20个字符
  页面初始化
  取消
  确认
  请按要求完善表单信息
  巡查点名称
  请输入巡检点名称
  巡检设备类型
  请选择父项类型
  请选择子项类型
  巡检设备类型
  无匹配项
  暂无数据
  请选择巡检设备类型
  已选巡检设备类型
  提交中
  提交
  取 消
  巡查点名称不能为空
  初始化巡查树
  取消
  确认
  请按要求完善表单信息
  请选择巡检设备类型
  请选择巡检设备类型
  获取父级设备类型
  暂无数据
  子项类型暂无数据，请重新选择父项类型
  子项类型存在，请进行选择
  第一个等同于第二个，splice方法删除第二个
  巡检设备类型已存在,请重新选择
  第一个等同于第二个，splice方法删除第二个
  巡检设备类型已存在,请重新选择
  第一个等同于第二个，splice方法删除第二个
  删除
  删除
  此操作将永久删除该内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  名称校验
  巡检点名称不能为空
  巡检点名称长度不能超过20个字符
  巡检点名称名长度不能少于1个字符
  巡检点名称不合法,请输入由
  或英文字符或数字组成的用户名！
  获取树结构巡检设备类型
  树形结构
  去掉children
  null的属性
  巡查点名称
  请输入巡检点名称
  巡检设备类型
  无匹配项
  暂无数据
  请选择巡检设备类型
  清除
  已选巡检设备类型
  提交中
  提交
  取 消
  巡查点名称不能为空
  巡检设备类型不能为空
  初始化巡查树
  取消
  确认
  请按要求完善表单信息
  删除
  删除
  此操作将永久删除该内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  名称校验
  巡检点名称不能为空
  巡检点名称长度不能超过20个字符
  巡检点名称名长度不能少于1个字符
  巡检点名称不合法,请输入由
  或英文字符或数字组成的用户名！
  获取树结构巡检设备类型
  巡检设备类型重复，请重新选择
  巡检设备类型重复，请重新选择
  树形结构
  去掉children
  null的属性
  巡查单查看
  巡检计划名称
  巡检时间
  至今
  至
  巡检员
  巡检单状态
  进行中
  已结束
  巡检模板
  巡检点
  巡检设备类型
  巡检内容
  描述
  巡检状态
  正常
  异常
  处理意见
  签名
  巡查报表
  巡查报表初始化
  关闭
  转换时间
  暂无时间
  为表格内取到的后台时间
  巡检类型名称
  请输入巡检类型名称
  是否设备类型
  是
  否
  提交中
  提交
  取 消
  请选择是否为设备类型
  页面数据校验
  巡检类型名称不能为空
  巡检类型名称长度不能超过20个字符
  取消
  确认
  请按要求完善表单信息
  消防巡检
  添加打印事件
  消防巡检
  添加打印事件
  模板名称
  请输入模板名称
  巡检点
  请选择巡检点
  巡检类型
  请选巡检类型
  巡检内容
  保存
  删除
  序号
  模板名称
  巡检点
  巡检设备类型
  巡检内容
  操作
  删除
  提交中
  提交
  取 消
  页面数据校验
  模板名称不能为空
  模板名称长度不能超过20个字符
  页面初始化
  取消
  确认
  请填写模板名称
  请按要求完善表单信息
  请填写模板名称
  第一个等同于第二个，splice方法删除第二个
  巡检设备类型已存在
  第一个等同于第二个，splice方法删除第二个
  第一个等同于第二个，splice方法删除第二个
  巡检设备类型已存在
  第一个等同于第二个，splice方法删除第二个
  第一个等同于第二个，splice方法删除第二个
  删除
  删除
  此操作将永久删除该内容, 是否继续
  提示
  确定
  取消
  删除成功!
  第一个等同于第二个，splice方法删除第二个
  已取消删除
  获取巡检模板下拉列表显示巡检点信息1
  获取巡检模板下拉列表显示巡检类型信息2
  getItemInfo获取巡检模板下拉列表显示巡检项信息3
  第一个等同于第二个，splice方法删除第二个
  模板名称
  请输入模板名称
  巡检点
  请选择巡检点
  巡检类型
  请选巡检类型
  巡检内容
  添加
  删除
  序号
  模板名称
  巡检点
  巡检设备类型
  巡检内容
  操作
  删除
  完成
  取 消
  页面数据校验
  模板名称不能为空
  模板名称长度不能超过20个字符
  页面初始化
  取消
  确认
  请填写模板名称
  请选择巡检点
  请选择巡检设备类型
  第一个等同于第二个，splice方法删除第二个
  巡检点已存在
  第一个等同于第二个，splice方法删除第二个
  第一个等同于第二个，splice方法删除第二个
  巡检点已存在
  请按要求完善表单信息
  删除
  删除
  此操作将永久删除该内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  获取巡检模板下拉列表显示巡检点信息1
  获取巡检模板下拉列表显示巡检类型信息2
  getItemInfo获取巡检模板下拉列表显示巡检项信息3
  区域
  请选择区域
  请选择区域
  提交中
  提交
  取 消
  请选择区域
  区域机构
  登录名
  昵称
  树节点选中传入的值
  树节点选中传入的值
  父穿子
  添加
  表格展示条数变化时
  表格展示条数变化时
  负责人角色
  安装员角色
  树节点选中接收值
  树节点选中接收值
  定义一个临时数组 
  循环遍历当前数组 
  判断当前数组下标为i的元素是否已经保存到临时数组 
  如果已保存，则跳过，否则将此元素保存到临时数组中 
  全选
  全不选
  树
  提交
  提交
  请正确填写相关信息！
  请先选择区域！
  重置
  树形结构
  去掉children
  null的属性
  区域名称
  请输入区域名称
  区域类别
  请选择区域类别
  建筑结构
  请选择建筑结构
  消防电梯
  请输入消防电梯
  部
  火灾危险性
  请选择火灾危险性
  耐火等级
  请选择耐火等级
  火种情况
  有明火
  无明火
  消防重点部位
  是
  负责人员
  请选择负责人员
  区域底图
  提交中
  提交
  取 消
  展示单个图片
  添加
  这里的userList就是上面遍历的数据源
  筛选出匹配数据
  这里的userList就是上面遍历的数据源
  筛选出匹配数据
  这里的userList就是上面遍历的数据源
  筛选出匹配数据
  取消
  请按要求完善表单信息
  确认
  添加成功！
  修改成功！
  上传图标事件
  对上传图片的大小
  格式进行限制
  只支持svg或jpeg或jpg或png格式图片
  请上传1MB以内的图片!
  名称不能为空
  名称长度不能超过20个字符
  名称长度不能少于1个字符
  名称不合法,设备名称中不能包含特殊符号！
  消防电梯数不能为空
  消防电梯数不能超过20个字符
  消防电梯数不能少于1个字符
  消防电梯数不合法,请输入由正整数组成的数字！
  多选框
  安装人列表
  搜索
  请输入昵称
  昵称
  登录名
  回显
  所有选中状态
  所有选中id
  表格数据
  删除两个数组中id相同的对象
  的方法
  pageSize变化时函数
  当前页变化时函数
  记录翻页选中
  选择的表单
  对选中数据处理，需要处理数据，用于传递给后台
  去重获取被选中的id值存入到数组中
  回显
  右边阴影
  负责人列表
  搜索
  请输入昵称
  昵称
  登录名
  回显
  所有选中状态
  所有选中id
  表格数据
  删除两个数组中id相同的对象
  的方法
  pageSize变化时函数
  当前页变化时函数
  记录翻页选中
  选择的表单
  对选中数据处理，需要处理数据，用于传递给后台
  去重获取被选中的id值存入到数组中
  回显
  右边阴影
  父模块ID
  请输入父模块ID
  模块名称
  请输入模块名称
  模块备注
  请输入模块备注
  模板组件名称
  请输入模板组件名称
  模板图片名称
  请输入模板图片名称
  是否仅允许超级管理员查看
  是
  否
  提交
  取 消
  取消
  请按要求完善表单信息
  名称不能为空
  名称长度不能超过20个字符
  名称长度不能少于1个字符
  名称不合法,设备名称中不能包含特殊符号！
  当包含页面时,组件名称为必填项
  当包含页面时,组件路径为必填项
  多选框
  全屏
  保存配置
  退出预览
  大屏头部 
  保存配置
  退出预览
  预览界面
  设备总数
  在线设备
  今日新增
  今日报警
  今日故障
  地图中间顶部统计数据
  编辑成功
  地图
  获取行政区域
  网上查了下，东西经南北纬的范围
  东北角
  西北角
  西南角
  东南角
  添加环形遮罩层
  中国
  建立多边形覆盖物
  给目标行政区划添加边框，其实就是给目标行政区划添加一个没有填充物的遮罩层
  调整视野
  区域
  烟感
  指定定位位置
  设置图片偏移
  指定定位位置
  设置图片偏移
  燃气
  指定定位位置
  设置图片偏移
  指定定位位置
  设置图片偏移
  其他离线
  指定定位位置
  设置图片偏移
  指定定位位置
  设置图片偏移
  创建信息窗口对象
  信息窗口宽度
  信息窗口高度
  设置允许信息窗发送短息
  管理方
  安装位置
  安装时间
  注册时间
  创建时间
  开启信息窗口
  最简单的用法，生成一个marker数组，然后调用markerClusterer类即可
  点聚合
  地图
  拖拉
  首先把div变成可以放置的元素，即重写dragenter
  在dragenter中针对放置目标来设置!
  为需要移动的元素设置dragstart事件
  拖拉
  前缀
  序号
  请输入序号
  名称
  请输入名称
  请输入名称
  图片
  注
  若要修改图片，请删除该整条信息后重新添加
  链接
  请输入点击图片后的跳转链接
  提交
  取消
  必填
  展示单个图片
  不能为空
  不能为空
  轮播图名称不能为空
  格式错误，例
  对上传图片的大小
  格式进行限制
  只支持jpeg或jpg或png格式图片
  请上传1MB以内的图片!
  图片上传成功
  请按要求完善表单信息
  请上传图片！
  添加成功
  编辑成功
  今日火警
  报警时间
  报警内容
  报警类型
  设备编码
  设备名称
  设备类型
  安装位置
  报警时间
  报警内容
  报警类型
  设备编码
  设备名称
  设备类型
  安装位置
  故障时间
  故障内容
  故障类型
  设备编码
  设备名称
  设备类型
  无
  安装位置
  真是火警
  误报
  转换时间
  暂无时间
  为表格内取到的后台时间
  表格当前页变化时
  表格展示条数变化时
  所属单位
  单位名称
  请输入单位名称
  所属行业
  请选择所属行业
  消防级别
  请选择消防级别
  组织机构代码
  请输入组织机构代码
  单位地址
  请输入单位地址
  法定代表人
  请输入法定代表人
  联系电话
  请输入法人联系电话
  消防安全管理人
  请输入消防安全管理人
  联系电话
  请输入联系电话
  消防安全责任人
  请输入消防安全责任人
  联系电话
  请输入联系电话
  专职消防人
  请输入专职消防人
  人
  义务消防人
  请输入义务消防人
  人
  建筑面积
  请输入建筑面积
  平方米
  安全出口数
  请输入安全出口数
  消防车道数
  请输入消防车道数
  疏散楼梯数
  请输入疏散楼梯数
  消防电梯数
  请输入消防电梯数
  避难层数
  请输入避难层数
  避难层位置
  请输入避难层位置
  避难层总面积
  请输入避难层总面积
  平方米
  公司图片
  提交中
  提交
  取 消
  展示单个图片
  所属行业不能为空
  防火等级不能为空
  单位地址不能为空
  联系电话不能为空
  联系电话不能为空
  对上传图片的大小
  格式进行限制
  只支持jpeg或jpg或png格式图片
  请上传1MB以内的图片!
  取消
  确认
  通过 FormData 对象上传文件
  请按要求完善表单信息
  添加成功
  预留 关闭子页面 刷新父页面数据
  新增失败
  修改成功
  预留 关闭子页面 刷新父页面数据
  编辑失败
  地图定位
  单位名称不能为空
  格式不合法,单位名称不能为空格，且首尾不能有空格！
  组织机构代码不能为空
  组织机构代码长度必须为18个字符
  格式不合法,请输入由英文
  或数字组成的编码！
  企业法人不能为空
  联系电话不能为空
  格式不合法,请输入正确的11位数字组成的联系电话！
  安全管理人不能为空
  格式不合法,请输入由英文
  或中文汉字组成的安全管理人！
  安全责任人不能为空
  格式不合法,请输入由英文
  或中文汉字组成的安全责任人！
  专职消防人数不能为空
  格式不合法,请输入由正整数组成的数字！
  义务消防人数不能为空
  格式不合法,请输入由正整数组成的数字！
  建筑面积不能为空
  格式不合法,请输入由正整数及正浮点数组成的数字！
  安全出口数不能为空
  格式不合法,请输入由正整数组成的数字！
  消防车道数不能为空
  格式不合法,请输入由正整数组成的数字！
  疏散楼梯数不能为空
  格式不合法,请输入由正整数组成的数字！
  消防电梯数不能为空
  格式不合法,请输入由正整数组成的数字！
  避难层数不能为空
  格式不合法,请输入由正整数组成的数字！
  避难层总面积不能为空
  格式不合法,请输入由正整数及正浮点数组成的数字！
  针对特定websocket server，定制的Stomp
  Websocket通信封装类
  baseUrl为可选参数
  需要确保stompUser为真
  建立与server的连接
  创建连接时错误
  连接建立后的错误，都会被监听
  连接websocket服务器
  注意
  创建连接时错误
  连接建立后的错误，都会被监听
  断开与server的连接
  当前还未与server建立连接
  订阅stompUser的某个目的地
  当前还未与server建立连接
  订阅路径为相对于websocket server的相对路径，不能加
  前缀
  因为已与server建立了连接
  使用stompUser身份，向某个应用目的地发送数据
  当前还未与server建立连接
  发送路径为相对于websocket server的相对路径，不能加
  前缀
  因为已与server建立了连接
  请求错误
  未授权，请重新登录
  拒绝访问
  请求出错
  请求超时
  服务器错误
  服务未实现
  网络错误
  服务不可用
  网络超时
  HTTP版本不受支持
  连接出错
  Session过期，请重新登录!
  清除session
  session过期
  清除session
  Session过期，请重新登录!
  在请求之前对data传参进行格式转换
  在请求之前对data传参进行格式转换
  地图容器 
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  区域
  至
  开始日期
  结束日期
  设备类型
  报警区域
  处理进度
  请输入报警内容
  报警等级
  搜索
  报表导出
  批量处理
  设备名称
  设备ID
  设备IMEI
  设备种类
  设备注册至
  祥云
  联通
  电信
  设备安装位置
  报警时间
  报警内容
  处理状态
  已处理
  未处理
  通知记录
  查看
  操作
  处理
  查看处理原因
  最近一周
  最近一个月
  未处理
  已处理
  一级报警
  二级报警
  三级报警
  查询区域 
  不用
  查询区域
  区域机构
  默认展开第一层根节点
  节点渲染完成后，加载第二层节点的核心代码
  区域
  终端出库设备
  终端出库设备
  终端出库设备
  节点点击发生变化时，触发事件
  查询
  搜索
  一级报警
  二级报警
  三级报警
  表格当前页变化时
  表格展示条数变化时
  鸡肋
  输入开始日期年份大于当前年份，请重新输入！
  输入结束日期年份大于当前年份，请重新输入！
  选择时间小于系统开始时间，请重新输入！
  查询月份的报警分表不存在
  请选择开始日期和结束日期！
  查询月份的报警分表不存在
  查询月份的报警分表不存在
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  通知记录
  关闭抽屉
  此操作将导出报表, 是否继续
  提示
  确定
  取消
  导出成功
  已取消导出
  未处理
  报警处理
  处理结果
  未处理
  此操作将处理报警, 是否继续
  提示
  确定
  取消
  报警处理
  已取消处理
  批量处理
  请勾选要处理的设备！
  报警批量处理
  设备管理
  控开设备
  设备列表
  设备列表
  左侧组织 
  区域
  设备名称
  设备类型
  是否安装
  已安装
  未安装
  是否注册
  已注册
  未注册
  是否在线
  在线
  离线
  设备类型
  是否报警
  报警
  未报警
  是否故障
  是
  否
  搜索
  实时统计
  实时统计
  离线
  离线
  离线
  市电
  离线
  离线
  请输入设备名称
  在线
  离线
  在线
  设备ID
  工作模式
  点动
  自锁
  互锁
  离线
  线路数
  暂无数据
  空开设置弹框 
  设置
  暂无数据
  路
  开启
  闭合 线路
  电流
  编辑详情
  名称
  请输入名称
  报警条件
  电压 
  电流 
  执行动作
  请选择
  保 存
  在线
  离线
  执行关闭
  执行开启
  只报警
  基本信息
  设备数据
  下发命令
  报警记录
  故障记录
  安装记录
  查询组织
  查询区域
  区域机构
  默认展开第一层根节点
  节点渲染完成后，加载第二层节点的核心代码
  区域
  终端出库设备
  终端出库设备
  终端出库设备
  节点点击发生变化时，触发事件
  查询
  搜索
  计算信号
  基本信息
  动态获取中间滚动高度,
  为头部和尾部的高度之和makeheightCons
  卡片点击设置
  离线
  离线状态下不允许操作设备
  编辑name
  编辑name
  设备名称不能为空！
  修改设备名称成功！
  网络异常，请稍后再试
  获取详情信息
  返回详情信息
  设置里的卡片点击编辑
  设置里的卡片点击编辑
  保存成功
  是否报警
  操作成功
  设备列表
  区域
  设备名称
  设备类型
  是否安装
  已安装
  未安装
  是否注册
  已注册
  未注册
  是否在线
  在线
  离线
  设备类型
  是否报警
  报警
  未报警
  是否故障
  是
  否
  实时统计
  搜索
  实时统计
  暂无数据
  设备列表
  设备列表
  在线
  离线
  基本信息
  设备数据
  下发命令
  报警记录
  故障记录
  安装记录
  查询组织
  查询区域
  查询区域
  区域机构
  默认展开第一层根节点
  节点渲染完成后，加载第二层节点的核心代码
  区域
  终端出库设备
  终端出库设备
  终端出库设备
  节点点击发生变化时，触发事件
  查询
  搜索
  在线状态
  报警状态
  类型名称
  安装位置
  更新时间
  注册类型
  在线状态
  报警状态
  注册状态
  安装状态
  创建时间
  基本信息
  动态获取中间滚动高度,
  为头部和尾部的高度之和makeheightCons
  设备列表
  区域
  终端设备
  设备名称
  设备类型
  是否安装
  已安装
  未安装
  是否注册
  已注册
  未注册
  是否在线
  在线
  离线
  设备类型
  是否报警
  报警
  未报警
  是否故障
  是
  否
  搜索
  实时统计
  搜索
  收起统计
  展开统计
  暂无数据
  设备列表
  设备信息
  在线
  离线
  基本信息
  设备数据
  下发命令
  报警记录
  故障记录
  安装记录
  是否是终端设备
  查询组织
  查询区域
  终端出库设备
  查询区域
  区域机构
  默认展开第一层根节点
  节点渲染完成后，加载第二层节点的核心代码
  终端出库设备
  区域
  终端出库设备
  终端出库设备
  终端出库设备
  节点点击发生变化时，触发事件
  查询
  搜索
  注册类型
  在线状态
  报警状态
  注册状态
  安装状态
  创建时间
  基本信息
  动态获取中间滚动高度,
  为头部和尾部的高度之和makeheightCons
  设备列表
  区域
  设备名称
  设备类型
  是否安装
  已安装
  未安装
  是否注册
  已注册
  未注册
  是否在线
  在线
  离线
  设备类型
  是否报警
  报警
  未报警
  是否故障
  是
  否
  一键布防
  批量布防
  实时统计
  实时统计
  全部
  确定
  复选框 
  单设备布防 
  布防
  撤防
  暂无数据
  设备列表
  设备列表
  设置布防撤防时间 
  开关
  撤防
  布防
  撤防
  布防
  布防开始时间
  布防开始时间
  布防结束时间
  布防开始时间
  保 存
  在线
  离线
  基本信息
  设备数据
  下发命令
  报警记录
  故障记录
  安装记录
  单设备布防
  查询组织
  查询区域
  查询区域
  区域机构
  默认展开第一层根节点
  节点渲染完成后，加载第二层节点的核心代码
  区域
  终端出库设备
  终端出库设备
  终端出库设备
  节点点击发生变化时，触发事件
  查询
  搜索
  注册类型
  在线状态
  报警状态
  注册状态
  安装状态
  创建时间
  基本信息
  动态获取中间滚动高度,
  为头部和尾部的高度之和makeheightCons
  切换布防or撤防
  撤防
  布防
  单设备布防
  单设备布防
  设备批量布防
  没有可布防的设备！
  设备批量布防
  一键布防
  没有可布防的设备！
  一键布防
  注意
  此操作将对所筛选的全部设备生效
  共
  台
  时间更改
  布防时间为
  至次日
  小时布防！
  设置保存
  时间不能为空！
  保存成功
  请选择设备！
  注意
  此操作将对您已选择的台设备生效
  共
  本页全选
  设备详情
  在线
  总数
  选择设备类型
  选择区域
  在线状态
  设备编码
  设备名称
  搜索
  设备安装
  报表导出
  批量删除
  设备名称
  设备编码
  设备类型
  在线状态
  在线
  离线
  所属单位
  安装区域
  安装位置
  安装时间
  操作
  编辑
  删除
  详情
  注册局部过滤器
  暂无时间
  为表格内取到的后台时间
  在线
  离线
  区域管理
  设备类型
  设备类型统计
  所有设备
  编辑
  编辑设备
  删除
  此操作将永久删除该内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  详情
  新增
  设备安装
  关闭抽屉
  确认
  取消
  查询
  搜索
  多选
  批量删除
  请先勾选删除内容！
  此操作将永久删除内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  报表导出
  没有进行条件筛选将导出全部数据，如果数据量过大请耐心等待，是否继续
  提示
  确定
  取消
  选择设备类型
  选择区域
  在线状态
  表格当前页变化时
  表格展示条数变化时
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  设备列表
  区域
  设备名称
  设备类型
  是否安装
  已安装
  未安装
  是否注册
  已注册
  未注册
  是否在线
  在线
  离线
  设备类型
  是否报警
  报警
  未报警
  是否故障
  是
  否
  搜索
  实时统计
  搜索
  收起统计
  展开统计
  离线
  离线
  位置
  区域
  负责人
  模组号
  暂无数据
  设备列表
  设备信息
  在线
  离线
  基本信息
  设备数据
  下发命令
  报警记录
  故障记录
  安装记录
  是否是终端设备
  查询组织
  查询区域
  终端出库设备
  查询区域
  区域机构
  默认展开第一层根节点
  节点渲染完成后，加载第二层节点的核心代码
  区域
  终端出库设备
  终端出库设备
  终端出库设备
  节点点击发生变化时，触发事件
  查询
  搜索
  基本信息
  动态获取中间滚动高度,
  为头部和尾部的高度之和makeheightCons
  设备列表
  区域
  设备名称
  设备类型
  是否安装
  已安装
  未安装
  是否注册
  已注册
  未注册
  是否在线
  在线
  离线
  设备类型
  是否报警
  报警
  未报警
  是否故障
  是
  否
  搜索
  实时统计
  搜索
  收起统计
  展开统计
  暂无数据
  设备列表
  设备信息
  在线
  离线
  基本信息
  设备数据
  下发命令
  报警记录
  故障记录
  安装记录
  是否是终端设备
  查询组织
  查询区域 
  不用
  终端出库设备
  查询区域
  区域机构
  默认展开第一层根节点
  节点渲染完成后，加载第二层节点的核心代码
  区域
  终端出库设备
  终端出库设备
  终端出库设备
  节点点击发生变化时，触发事件
  查询
  搜索
  注册类型
  在线状态
  报警状态
  注册状态
  安装状态
  创建时间
  基本信息
  动态获取中间滚动高度,
  为头部和尾部的高度之和makeheightCons
  设备列表
  区域
  设备名称
  设备类型
  是否安装
  已安装
  未安装
  是否注册
  已注册
  未注册
  是否在线
  在线
  离线
  设备类型
  是否报警
  报警
  未报警
  是否故障
  是
  否
  搜索
  实时统计
  离线
  离线
  信号值 
  离线
  电量 
  离线
  详情按钮 
  设置按钮 
  离线
  离线中
  启用 
  活跃
  无人
  活跃
  无人
  驻留
  未驻留
  驻留
  未驻留
  跌倒
  跌倒
  正常
  监测中
  未启用 
  未启用
  离线
  报警中
  离线
  撤防
  布防
  撤防
  布防
  位置
  雷达频率
  模组号
  暂无数据
  设备列表
  设备信息
  设置
  名称
  请输入名称
  报警条件1
  请选择
  报警条件2
  请选择
  保 存
  在线
  离线
  基本信息
  设备数据
  下发命令
  报警记录
  故障记录
  安装记录
  是否是终端设备
  不报警
  活跃报警
  无人报警
  不报警
  驻留报警
  未驻留报警
  查询组织
  查询区域
  终端出库设备
  查询区域
  区域机构
  默认展开第一层根节点
  节点渲染完成后，加载第二层节点的核心代码
  区域
  终端出库设备
  终端出库设备
  终端出库设备
  节点点击发生变化时，触发事件
  查询
  搜索
  在线
  计算信号 7, 15, 24,31
  基本信息
  切换布防or撤防
  离线
  离线状态下不允许操作设备
  切换布防or撤防
  离线
  离线状态下不允许操作设备
  撤防
  布防
  操作成功！
  动态获取中间滚动高度,
  为头部和尾部的高度之和makeheightCons
  设置保存
  保存成功
  设备列表
  区域
  设备名称
  设备类型
  是否安装
  已安装
  未安装
  是否注册
  已注册
  未注册
  是否在线
  在线
  离线
  设备类型
  是否报警
  报警
  未报警
  是否故障
  是
  否
  搜索
  实时统计
  实时统计
  暂无数据
  设备列表
  设备列表
  在线
  离线
  基本信息
  设备数据
  下发命令
  报警记录
  故障记录
  安装记录
  查询组织
  查询区域
  查询区域
  区域机构
  默认展开第一层根节点
  节点渲染完成后，加载第二层节点的核心代码
  区域
  终端出库设备
  终端出库设备
  终端出库设备
  节点点击发生变化时，触发事件
  查询
  搜索
  在线状态
  报警状态
  类型名称
  安装位置
  更新时间
  注册类型
  在线状态
  报警状态
  注册状态
  安装状态
  创建时间
  基本信息
  动态获取中间滚动高度,
  为头部和尾部的高度之和makeheightCons
  设备类型详情
  在线
  总数
  选择设备注册至
  选择通信协议方式
  是否启用
  设备类型名称
  搜索
  新增设备类型
  报表导出
  批量删除
  设备类型名称
  设备注册至
  通信协议方式
  设备注册至
  祥云
  联通
  通信协议方式
  是否启用
  启用
  禁用
  设备心跳周期
  单位
  设备报警时间间隔
  单位
  安装位置
  添加时间
  操作
  编辑
  删除
  详情
  注册局部过滤器
  暂无时间
  为表格内取到的后台时间
  祥云
  联通
  启用
  禁用
  设备类型统计
  所有设备类型
  所有设备类型
  编辑
  编辑设备类型
  删除
  此操作将永久删除该内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  详情
  新增
  新增设备类型
  关闭抽屉
  确认
  取消
  查询
  搜索
  多选
  批量删除
  请先勾选删除内容！
  此操作将永久删除内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  报表导出
  没有进行条件筛选将导出全部数据，如果数据量过大请耐心等待，是否继续
  提示
  确定
  取消
  选择设备类型
  选择区域
  在线状态
  表格当前页变化时
  表格展示条数变化时
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  设备管理
  视频监控
  站点树形数据 
  视频区域 
  画面操作相关 
  清除视频 
  清除当前
  全部清除
  画面布局切换 
  监控画面 
  请添加监控视频
  布局切换配置数据
  单画面
  四画面
  九画面
  当前激活的布局tab索引
  视频实例初始化配置数据 容器id videoid
  当前选择的视频索引
  默认布局样式
  当前切换布局的播放器数量
  监控视频画面布局切换
  当前切换tab的索引
  无返回值
  视频选中
  当前选中视频的索引
  无返回值
  初始化视频
  视频链接
  选中要播放视频的框的索引
  无返回值
  销毁单个视频实例
  视频实例索引
  无返回值
  请添加监控视频
  销毁所有视频实例
  无
  无返回值
  请添加监控视频
  查询组织
  查询区域
  区域机构
  默认展开第一层根节点
  节点渲染完成后，加载第二层节点的核心代码
  区域
  终端出库设备
  终端出库设备
  终端出库设备
  节点点击发生变化时，触发事件
  设备列表
  区域
  设备名称
  设备类型
  是否安装
  已安装
  未安装
  是否注册
  已注册
  未注册
  是否在线
  在线
  离线
  设备类型
  是否报警
  报警
  未报警
  是否故障
  是
  否
  搜索
  搜索
  实时统计
  收起统计
  展开统计
  未启用
  报警中
  监控中
  撤防
  布防
  撤防
  布防
  位置
  区域
  负责人
  sim卡余期
  天
  模组号
  暂无数据
  设备列表
  设备信息
  在线
  离线
  基本信息
  设备数据
  下发命令
  报警记录
  故障记录
  安装记录
  是否是终端设备
  查询组织
  查询区域 
  不用
  终端出库设备
  查询区域
  区域机构
  默认展开第一层根节点
  节点渲染完成后，加载第二层节点的核心代码
  区域
  终端出库设备
  终端出库设备
  终端出库设备
  节点点击发生变化时，触发事件
  查询
  搜索
  基本信息
  切换布防or撤防
  撤防
  布防
  操作成功！
  动态获取中间滚动高度,
  为头部和尾部的高度之和makeheightCons
  设备详情
  安装设备
  安装记录
  类型分布
  启用
  在线统计
  在线
  安装统计
  已安装
  注册统计
  已注册
  在库统计
  在库
  报警统计
  已处理
  故障统计
  已处理
  总数
  设备类型分布
  启用
  设备在线统计
  在线
  设备安装统计
  已安装
  设备注册统计
  已注册
  设备在库统计
  在库
  报警处理状态统计
  已处理
  故障处理状态统计
  已处理
  总数
  区域
  手机号
  设备名称
  设备类型
  是否安装
  已安装
  未安装
  是否注册
  已注册
  未注册
  是否在线
  在线
  离线
  设备类型
  是否报警
  报警
  未报警
  是否故障
  是
  否
  搜索
  搜索
  设备导出
  批量拆卸
  设备导出
  单个入库
  批量入库
  批量删除
  批量注册
  未安装
  已注册
  未注册
  已安装
  报表导出
  设备名称
  设备编码
  设备类型
  注册类型
  联通
  祥云
  电信
  通信类型
  未知
  设备标签
  所属组织
  所属组织
  入库时间
  在线状态
  在线
  离线
  注册状态
  已注册
  未注册
  安装状态
  已安装
  未安装
  是否启用
  是
  否
  报警状态
  已报警
  未报警
  是否故障
  是
  否
  安装时间
  注册时间
  操作
  安装
  拆卸
  启用
  禁用
  注册
  解除注册
  安装记录
  编辑
  删除
  详情
  标签
  编辑标签
  标签
  请选择
  取 消
  确 定
  标签编辑成功
  标签编辑失败,请重新编辑！
  查询组织
  查询区域
  查询区域
  区域机构
  默认展开第一层根节点
  节点渲染完成后，加载第二层节点的核心代码
  区域
  终端出库设备
  终端出库设备
  终端出库设备
  节点点击发生变化时，触发事件
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  编辑
  编辑设备
  编辑设备
  删除
  此操作将永久删除该内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  编辑标签
  详情
  新增单个
  单个入库
  单个入库
  新增批量
  批量入库
  单个入库
  查询
  搜索
  设备导出
  此操作将导出报表, 是否继续
  提示
  确定
  取消
  导出成功
  已取消导出
  将当前时间转换成yyyy
  dd格式
  关闭抽屉
  确认 
  取消
  表格当前页变化时
  表格展示条数变化时
  已注册
  已安装
  未注册
  批量删除
  请先勾选删除内容！
  此操作将永久删除内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  批量注册
  请先勾选注册设备！
  此操作将注册设备, 是否继续
  提示
  确定
  取消
  注册成功!
  已取消注册
  此操作将注册该设备, 是否继续
  提示
  确定
  取消
  注册成功!
  已取消注册
  多选
  报表导出
  没有进行条件筛选将导出全部数据，如果数据量过大请耐心等待，是否继续
  提示
  确定
  取消
  设备类型统计
  类型分布
  设备在线统计
  在线统计
  设备安装统计
  安装统计
  设备注册统计
  注册统计
  设备在库统计
  在库统计
  报警处理状态统计
  报警统计
  故障处理状态统计
  故障统计
  请先勾选拆卸设备！
  此操作将拆除已选中的设备, 是否继续
  提示
  确定
  取消
  操作成功
  已取消操作
  此操作将拆卸设备, 是否继续
  提示
  确定
  取消
  已取消拆卸
  此操作将启用该设备, 是否继续
  提示
  确定
  取消
  操作成功
  已取消操作
  此操作将禁用该设备, 是否继续
  提示
  确定
  取消
  操作成功
  已取消操作
  此操作将注册, 是否继续
  提示
  确定
  取消
  已取消注册
  此操作将解除注册, 是否继续
  提示
  确定
  取消
  已取消解除注册
  设备列表
  区域
  设备名称
  设备类型
  是否安装
  已安装
  未安装
  是否注册
  已注册
  未注册
  是否在线
  在线
  离线
  设备类型
  是否报警
  报警
  未报警
  是否故障
  是
  否
  实时统计
  搜索
  实时统计
  暂无数据
  设备列表
  设备列表
  在线
  离线
  基本信息
  设备数据
  下发命令
  报警记录
  故障记录
  安装记录
  查询组织
  查询区域
  查询区域
  区域机构
  默认展开第一层根节点
  节点渲染完成后，加载第二层节点的核心代码
  区域
  终端出库设备
  终端出库设备
  终端出库设备
  节点点击发生变化时，触发事件
  查询
  搜索
  在线状态
  报警状态
  安装位置
  更新时间
  基本信息
  动态获取中间滚动高度,
  为头部和尾部的高度之和makeheightCons
  液位设备详情
  区域
  设备名称
  设备类型
  是否安装
  已安装
  未安装
  是否注册
  已注册
  未注册
  是否在线
  在线
  离线
  设备类型
  是否报警
  报警
  未报警
  是否故障
  是
  否
  搜索
  设备名称
  液位值
  设备类型名称
  在线状态
  注册状态
  注册类型
  安装状态
  是否启用
  报警状态
  是否故障
  信号值
  迁移值B
  迁移值K
  厂商编号
  采集间隔
  发送间隔
  波动值警告
  阈值上限
  阈值下限
  探测器类型
  探测器屏蔽标志
  探测器报警状态
  探测器故障状态
  通道1开关标志
  通道1报警标志
  通道1故障标志
  通道1类型
  通道1值
  通道1报警设定值
  通道2开关标志
  通道2报警标志
  通道2故障标志
  通道2类型
  通道2值
  通道2报警设定值
  通道3开关标志
  通道3报警标志
  通道3故障标志
  通道3类型
  通道3值
  通道3报警设定值
  通道4开关标志
  通道4报警标志
  通道4故障标志
  通道4类型
  通道4值
  通道4报警设定值
  通道5开关标志
  通道5报警标志
  通道5故障标志
  通道5类型
  通道5值
  通道5报警设定值
  通道6开关标志
  通道6报警标志
  通道6故障标志
  通道6类型
  通道7开关标志
  通道7报警标志
  通道7故障标志
  通道7类型
  通道7值
  通道7报警设定值
  通道8开关标志
  通道8报警标志
  通道8故障标志
  通道8类型
  通道8值
  通道9开关标志
  通道9报警标志
  通道9故障标志
  通道9类型
  通道9值
  通道10开关标志
  通道10报警标志
  通道10故障标志
  通道10类型
  通道10值
  通道11开关标志
  通道11报警标志
  通道11故障标志
  通道11类型
  通道11值
  断电故障标志
  A相电压报警标志
  B相电压报警标志
  C相电压报警标志
  A相电流报警标志
  B相电流报警标志
  C相电流报警标志
  相电压Va
  相电压Vb
  相电压Vc
  线电压Uab
  线电压Ubc
  线电压Uca
  相电流Ia
  相电流Ib
  相电流Ic
  A相有功功率
  B相有功功率
  C相有功功率
  A无功功率
  B无功功率
  C无功功率
  A视在功率
  B视在功率
  C视在功率
  总有功功率
  总无功功率
  总视在功率
  总电量
  电网频率
  A功率因数
  B功率因数
  C功率因数
  接线方式
  A相电压开关状态
  B相电压开关状态
  C相电压开关状态
  A相电流开关状态
  B相电流开关状态
  C相电流开关状态
  过压报警设定值
  欠压报警设定值
  A相过流设定值
  B相过流设定值
  C相过流设定值
  A相电流CT倍率
  B相电流CT倍率
  C相电流CT倍率
  BuzzerState蜂鸣器状态
  OutState输出状态
  InState输入状态
  创建时间
  更新时间
  操作
  删除
  详情
  查询组织
  查询区域
  查询区域
  区域机构
  默认展开第一层根节点
  节点渲染完成后，加载第二层节点的核心代码
  区域
  终端出库设备
  终端出库设备
  终端出库设备
  节点点击发生变化时，触发事件
  查询
  搜索
  表格展示条数变化时
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  已注册
  已安装
  已安装
  未注册
  批量删除
  请先勾选删除内容！
  此操作将永久删除内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  多选
  删除
  此操作将永久删除该内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  详情
  设备管理
  液位设备
  设备列表
  设备名称
  设备类型
  是否安装
  已安装
  未安装
  是否注册
  已注册
  未注册
  是否在线
  在线
  离线
  设备类型
  是否报警
  报警
  未报警
  是否故障
  是
  否
  搜索
  设备编号
  设备类型
  安装时间
  sim卡余期
  天
  历史报警走势
  报警记录
  暂无数据
  设备列表
  设备信息
  在线
  离线
  基本信息
  设备数据
  下发命令
  报警记录
  故障记录
  安装记录
  在线设备
  设备总数
  今日新增
  今日报警
  今日故障
  报警时间
  设备名称
  报警内容
  处理情况
  筛选条件
  设备类型
  查询
  搜索
  计算信号
  计算电量
  基本信息
  动态获取中间滚动高度,
  为头部和尾部的高度之和makeheightCons
  设备统计
  历史报警走势
  报警记录
  已处理
  未处理
  设备列表
  区域
  设备名称
  设备类型
  是否安装
  已安装
  未安装
  是否注册
  已注册
  未注册
  是否在线
  在线
  离线
  设备类型
  是否报警
  报警
  未报警
  是否故障
  是
  否
  搜索
  实时统计
  搜索
  收起统计
  展开统计
  未启用
  关闭报警
  开启报警
  报警
  关闭
  撤防
  布防
  撤防
  布防
  位置
  区域
  负责人
  sim卡余期
  天
  模组号
  暂无数据
  设备列表
  设备信息
  在线
  离线
  基本信息
  设备数据
  下发命令
  报警记录
  故障记录
  安装记录
  是否是终端设备
  查询组织
  查询区域 
  不用
  终端出库设备
  查询区域
  区域机构
  默认展开第一层根节点
  节点渲染完成后，加载第二层节点的核心代码
  区域
  终端出库设备
  终端出库设备
  终端出库设备
  节点点击发生变化时，触发事件
  查询
  搜索
  基本信息
  切换布防or撤防
  撤防
  布防
  操作成功！
  控制开启
  关闭报警 acoustoon
  开
  关
  操作成功！
  控制开启
  关闭报警 acoustoon
  开
  关
  操作成功！有延迟请耐心等待
  动态获取中间滚动高度,
  为头部和尾部的高度之和makeheightCons
  水压设备详情
  区域
  设备名称
  设备类型
  是否安装
  已安装
  未安装
  是否注册
  已注册
  未注册
  是否在线
  在线
  离线
  设备类型
  是否报警
  报警
  未报警
  是否故障
  是
  否
  搜索
  设备名称
  水压值
  设备类型名称
  在线状态
  注册状态
  注册类型
  安装状态
  是否启用
  报警状态
  是否故障
  信号值
  迁移值B
  迁移值K
  厂商编号
  采集间隔
  发送间隔
  波动值警告
  阈值上限
  阈值下限
  探测器类型
  探测器屏蔽标志
  探测器报警状态
  探测器故障状态
  通道1开关标志
  通道1报警标志
  通道1故障标志
  通道1类型
  通道1值
  通道1报警设定值
  通道2开关标志
  通道2报警标志
  通道2故障标志
  通道2类型
  通道2值
  通道2报警设定值
  通道3开关标志
  通道3报警标志
  通道3故障标志
  通道3类型
  通道3值
  通道3报警设定值
  通道4开关标志
  通道4报警标志
  通道4故障标志
  通道4类型
  通道4值
  通道4报警设定值
  通道5开关标志
  通道5报警标志
  通道5故障标志
  通道5类型
  通道5值
  通道5报警设定值
  通道6开关标志
  通道6报警标志
  通道6故障标志
  通道6类型
  通道7开关标志
  通道7报警标志
  通道7故障标志
  通道7类型
  通道7值
  通道7报警设定值
  通道8开关标志
  通道8报警标志
  通道8故障标志
  通道8类型
  通道8值
  通道9开关标志
  通道9报警标志
  通道9故障标志
  通道9类型
  通道9值
  通道10开关标志
  通道10报警标志
  通道10故障标志
  通道10类型
  通道10值
  通道11开关标志
  通道11报警标志
  通道11故障标志
  通道11类型
  通道11值
  断电故障标志
  A相电压报警标志
  B相电压报警标志
  C相电压报警标志
  A相电流报警标志
  B相电流报警标志
  C相电流报警标志
  相电压Va
  相电压Vb
  相电压Vc
  线电压Uab
  线电压Ubc
  线电压Uca
  相电流Ia
  相电流Ib
  相电流Ic
  A相有功功率
  B相有功功率
  C相有功功率
  A无功功率
  B无功功率
  C无功功率
  A视在功率
  B视在功率
  C视在功率
  总有功功率
  总无功功率
  总视在功率
  总电量
  电网频率
  A功率因数
  B功率因数
  C功率因数
  接线方式
  A相电压开关状态
  B相电压开关状态
  C相电压开关状态
  A相电流开关状态
  B相电流开关状态
  C相电流开关状态
  过压报警设定值
  欠压报警设定值
  A相过流设定值
  B相过流设定值
  C相过流设定值
  A相电流CT倍率
  B相电流CT倍率
  C相电流CT倍率
  BuzzerState蜂鸣器状态
  OutState输出状态
  InState输入状态
  创建时间
  更新时间
  操作
  删除
  详情
  查询组织
  查询区域
  查询区域
  区域机构
  默认展开第一层根节点
  节点渲染完成后，加载第二层节点的核心代码
  区域
  终端出库设备
  终端出库设备
  终端出库设备
  节点点击发生变化时，触发事件
  查询
  搜索
  表格展示条数变化时
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  已注册
  已安装
  已安装
  未注册
  批量删除
  请先勾选删除内容！
  此操作将永久删除内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  多选
  删除
  此操作将永久删除该内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  详情
  设备管理
  水压设备
  设备列表
  设备名称
  设备类型
  是否安装
  已安装
  未安装
  是否注册
  已注册
  未注册
  是否在线
  在线
  离线
  设备类型
  是否报警
  报警
  未报警
  是否故障
  是
  否
  搜索
  设备编号
  设备类型
  安装时间
  sim卡余期
  天
  历史报警走势
  报警记录
  暂无数据
  设备列表
  设备信息
  在线
  离线
  基本信息
  设备数据
  下发命令
  报警记录
  故障记录
  安装记录
  在线设备
  设备总数
  今日新增
  今日报警
  今日故障
  报警时间
  设备名称
  报警内容
  处理情况
  筛选条件
  设备类型
  筛选条件
  设备类型
  查询
  搜索
  计算信号
  计算电量
  注册类型
  报警状态
  在线状态
  注册状态
  安装状态
  最新数据时间
  基本信息
  动态获取中间滚动高度,
  为头部和尾部的高度之和makeheightCons
  设备统计
  历史报警走势
  报警记录
  报警时间
  设备名称
  报警内容
  处理情况
  已处理
  未处理
  至
  开始日期
  结束日期
  设备类型
  报警区域
  处理进度
  请输入报警内容
  报警等级
  设备类型
  查询
  查询
  报表导出
  设备名称
  设备ID
  设备IMEI
  设备种类
  设备注册至
  祥云
  联通
  设备安装位置
  报警时间
  报警内容
  处理状态
  已处理
  未处理
  通知记录
  查看
  操作
  处理
  最近一周
  最近一个月
  未处理
  已处理
  一级报警
  二级报警
  三级报警
  查询
  查询
  表格展示条数变化时
  输入开始日期年份大于当前年份，请重新输入！
  输入结束日期年份大于当前年份，请重新输入！
  选择时间小于系统开始时间，请重新输入！
  查询月份的报警分表不存在
  请选择开始日期和结束日期！
  查询月份的报警分表不存在
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  通知记录
  关闭抽屉
  此操作将导出报表, 是否继续
  提示
  确定
  取消
  导出成功
  已取消导出
  未处理
  报警处理
  处理结果
  未处理
  此操作将处理报警, 是否继续
  提示
  确定
  取消
  报警处理
  报警处理
  已取消处理
  基本信息
  设备名称
  设备ID
  安装区域
  请选择区域
  请选择区域
  是否注册
  已注册
  设备注册至
  是否安装
  报警状态
  故障状态
  是否启用
  是否在线
  通知人员类型
  通知负责人
  通知安装人
  通知安装人和负责人
  通信类型
  已安装
  设备定位
  已安装
  安装经纬度
  已安装
  安装位置
  已安装
  安装时间
  使用者
  使用者联系方式
  已安装
  安装人员
  已安装
  安装人员联系方式
  入库时间
  已注册
  注册时间
  硬件版本
  软件版本
  厂商编号
  开关数量
  串口数量
  信号强度
  通讯类型
  温度
  负责人
  联系方式
  编辑
  提交
  取消
  拆除
  解除
  解除
  请输入关键字
  搜索地址
  保存位置
  区域机构
  看一级区域机构里有没有已填写的安装区域，没有则先
  请选择有效的安装区域！
  重置
  去掉children
  null的属性
  点击弹框
  选择位置
  初始化地图
  缩放条
  异步加载插件
  地图定位到选中项位置
  创建标注
  将标注添加到地图中
  详情
  根据坐标显示设备定位address
  result为对应的地理位置详细信息
  创建标注
  将标注添加到地图中
  请选择有效的安装区域！
  此操作将修改设备信息, 是否继续
  提示
  确定
  取消
  已取消修改
  此操作将拆除设备, 是否继续
  提示
  确定
  取消
  已取消拆
  解除
  此操作将解除设备, 是否继续
  提示
  确定
  取消
  已取消拆
  请您先选择地理位置
  创建标注
  将标注添加到地图中
  转化前
  转化后
  创建标注
  将标注添加到地图中
  创建标注
  将标注添加到地图中
  全选
  全选
  删除
  设置表格最大高度
  设置表格最大高度
  是否显示加载中
  表格数据
  可选的pageSizes
  需要展示的page的控件的数组
  表格行的类名
  表格表头的类名
  存放选中值的数组
  pageSize变化时函数
  当前页变化时函数
  多选框的选项变化是触发函数
  选中的值
  全选
  请先勾选删除内容！
  此操作将永久删除内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  右边阴影
  全选
  全选
  删除
  设置表格最大高度
  设置表格最大高度
  是否显示加载中
  表格数据
  可选的pageSizes
  需要展示的page的控件的数组
  表格行的类名
  表格表头的类名
  存放选中值的数组
  pageSize变化时函数
  当前页变化时函数
  多选框的选项变化是触发函数
  选中的值
  全选
  请先勾选删除内容！
  此操作将永久删除内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  右边阴影
  实时数据
  关闭实时更新
  开启实时更新
  暂无数据
  历史数据
  列表展示
  曲线展示
  至
  开始日期
  结束日期
  请输入字段名称
  查询
  最新数据更新时间
  暂无
  序号
  设备属性名称
  更新时间
  暂无数据
  选择日期
  查询
  禁止选择本日之后
  一天
  一周
  一个月
  处的颜色
  处的颜色
  处的颜色
  缺省为 false
  日期
  坐标轴轴线相关设置
  数学上的x轴
  坐标轴刻度标签的相关设置
  报警次数
  最大值
  最小值
  最近一周
  最近一个月
  通过函数改变数据从而达到视图的改变
  设备实时数据
  请您选择日期！
  查询
  查询
  表格展示条数变化时
  输入开始日期年份大于当前年份，请重新输入！
  输入结束日期年份大于当前年份，请重新输入！
  选择时间小于系统开始时间，请重新输入！
  查询月份的报警分表不存在
  请选择开始日期和结束日期！
  查询月份的报警分表不存在
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  历史曲线
  没有找到您要查询的相关数据
  没有找到您要查询的相关数据
  没有找到您要查询的相关数据
  请您选择日期！
  此操作将开启实时更新, 是否继续
  提示
  确定
  取消
  已取消
  此操作将关闭实时更新, 是否继续
  提示
  确定
  取消
  已取消
  调取接口获取数据
  四周阴影
  四周阴影
  修改高度
  左右箭头的样式
  在线设备
  设备总数
  今日新增
  今日报警
  历史报警走势
  最新报警记录
  序号
  设备名称
  设备IMEI
  报警内容
  安装位置
  报警时间
  暂无数据
  处的颜色
  处的颜色
  处的颜色
  缺省为 false
  日期
  坐标轴轴线相关设置
  数学上的x轴
  坐标轴刻度标签的相关设置
  报警次数
  最大值
  最小值
  没有找到您要查询的相关数据
  鼠标悬停停止滚动
  向下
  上滚动
  滚动速度
  滚动单行
  单行停顿时间
  获取当天履职列表
  在线设备
  设备总数
  今日新增
  今日报警
  今日故障
  历史报警走势
  没有找到您要查询的相关数据
  没有找到您要查询的相关数据
  没有找到您要查询的相关数据
  获取最新报警
  至
  开始日期
  结束日期
  处理进度
  请输入故障内容
  设备类型
  查询
  查询
  报表导出
  设备名称
  设备ID
  设备IMEI
  设备种类
  设备注册至
  祥云
  联通
  设备安装位置
  故障时间
  故障内容
  处理状态
  已处理
  未处理
  通知记录
  查看
  操作
  处理
  最近一周
  最近一个月
  未处理
  已处理
  查询
  查询
  表格展示条数变化时
  此操作将处理故障, 是否继续
  提示
  确定
  取消
  已取消处理
  版权 获取当前年
  输入开始日期年份大于当前年份，请重新输入！
  输入结束日期年份大于当前年份，请重新输入！
  选择时间小于系统开始时间，请重新输入！
  查询月份的报警分表不存在
  请选择开始日期和结束日期！
  查询月份的报警分表不存在
  通知记录
  关闭抽屉
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  此操作将导出报表, 是否继续
  提示
  确定
  取消
  导出成功
  已取消导出
  请输入关键字
  操作类型
  拆卸
  安装
  查询
  查询
  操作类型
  安装
  拆卸
  是否租户操作
  是
  否
  操作者
  安装位置
  操作时间
  使用时长
  暂无
  查询
  查询
  表格展示条数变化时
  命令
  记录
  至
  开始日期
  结束日期
  下发命令
  复位
  消音
  手动报警
  自检
  下发结果
  成功
  失败
  查询
  设备名称
  命令
  复位
  消音
  手动报警
  自检
  失败信息
  下发时间
  下发结果
  成功
  失败
  禁止选择本日之后
  最近一周
  最近一个月
  复位
  消音
  手动报警
  自检
  请您选择日期！
  查询
  查询
  表格展示条数变化时
  输入开始日期年份大于当前年份，请重新输入！
  输入结束日期年份大于当前年份，请重新输入！
  选择时间小于系统开始时间，请重新输入！
  查询月份的报警分表不存在
  请选择开始日期和结束日期！
  查询月份的报警分表不存在
  下发命令
  下发命令成功！
  修改高度
  左右箭头的样式
  基本信息
  设备名称
  设备ID
  安装区域
  请选择区域
  请选择区域
  设备类型名称
  是否注册
  已注册
  设备注册至
  是否安装
  报警状态
  故障状态
  是否启用
  是否在线
  数据最新时间
  无
  通知人员类型
  通知负责人
  通知安装人
  通知安装人和负责人
  通信类型
  已安装
  设备定位
  已安装
  安装经纬度
  已安装
  安装位置
  已安装
  安装时间
  使用者
  使用者联系方式
  已安装
  安装人员
  已安装
  安装人员联系方式
  入库时间
  已注册
  注册时间
  硬件版本
  软件版本
  采集协议
  设备数据推送地址
  传感器总数
  从站类
  无线信号值
  无线类型
  负责人
  联系方式
  编辑
  提交
  取消
  拆除
  请输入关键字
  搜索地址
  保存位置
  区域机构
  重置
  去掉children
  null的属性
  点击弹框
  选择位置
  初始化地图
  缩放条
  异步加载插件
  地图定位到选中项位置
  创建标注
  将标注添加到地图中
  详情
  根据坐标显示设备定位address
  result为对应的地理位置详细信息
  创建标注
  将标注添加到地图中
  此操作将修改设备信息, 是否继续
  提示
  确定
  取消
  已取消修改
  此操作将拆除设备, 是否继续
  提示
  确定
  取消
  已取消拆除
  请您先选择地理位置
  创建标注
  将标注添加到地图中
  转化前
  转化后
  创建标注
  将标注添加到地图中
  创建标注
  将标注添加到地图中
  离线
  报警中
  在线
  正常
  在线
  查看
  编辑
  删除
  基本信息
  设备名称
  设备ID
  安装区域
  请选择区域
  请选择区域
  设备类型名称
  是否注册
  已注册
  设备注册至
  是否安装
  报警状态
  故障状态
  是否启用
  是否在线
  数据最新时间
  无
  通知人员类型
  通知负责人
  通知安装人
  通知安装人和负责人
  通信类型
  已安装
  设备定位
  已安装
  安装经纬度
  已安装
  安装位置
  已安装
  安装时间
  使用者
  使用者联系方式
  已安装
  安装人员
  已安装
  安装人员联系方式
  入库时间
  已注册
  注册时间
  硬件版本
  软件版本
  采集协议
  设备数据推送地址
  传感器总数
  从站类
  无线信号值
  无线类型
  负责人
  联系方式
  编辑
  提交
  取消
  拆除
  请输入关键字
  搜索地址
  保存位置
  区域机构
  请选择有效的安装区域！
  重置
  去掉children
  null的属性
  点击弹框
  选择位置
  初始化地图
  缩放条
  异步加载插件
  地图定位到选中项位置
  创建标注
  将标注添加到地图中
  详情
  result为对应的地理位置详细信息
  创建标注
  将标注添加到地图中
  请选择有效的安装区域！
  此操作将修改设备信息, 是否继续
  提示
  确定
  取消
  已取消修改
  此操作将拆除设备, 是否继续
  提示
  确定
  取消
  已取消拆除
  请您先选择地理位置
  创建标注
  将标注添加到地图中
  转化前
  转化后
  创建标注
  将标注添加到地图中
  创建标注
  将标注添加到地图中
  全选
  全选
  删除
  设置表格最大高度
  设置表格最大高度
  是否显示加载中
  表格数据
  可选的pageSizes
  需要展示的page的控件的数组
  表格行的类名
  表格表头的类名
  存放选中值的数组
  pageSize变化时函数
  当前页变化时函数
  多选框的选项变化是触发函数
  选中的值
  全选
  请先勾选删除内容！
  此操作将永久删除内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  右边阴影
  离线
  报警中
  在线
  正常
  在线
  查看
  编辑
  删除
  报警次数
  处的颜色
  处的颜色
  处的颜色
  缺省为 false
  至
  开始日期
  结束日期
  报警状态
  请输入报警内容
  查询
  状态
  设备名称
  设备安装位置
  报警内容
  报警时间
  最近一周
  最近一个月
  低报
  低报
  高报
  高报
  掉电
  掉电
  超量程
  超量程
  一级报警
  二级报警
  三级报警
  查询
  查询
  表格展示条数变化时
  输入开始日期年份大于当前年份，请重新输入！
  输入结束日期年份大于当前年份，请重新输入！
  选择时间小于系统开始时间，请重新输入！
  查询月份的报警分表不存在
  请选择开始日期和结束日期！
  查询月份的报警分表不存在
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  基本信息
  设备名称
  设备ID
  安装区域
  请选择区域
  请选择区域
  设备类型名称
  是否注册
  已注册
  设备注册至
  是否安装
  报警状态
  故障状态
  是否启用
  是否在线
  数据最新时间
  无
  通知人员类型
  通知负责人
  通知安装人
  通知安装人和负责人
  通信类型
  已安装
  设备定位
  已安装
  安装经纬度
  已安装
  安装位置
  已安装
  安装时间
  使用者
  使用者联系方式
  已安装
  安装人员
  已安装
  安装人员联系方式
  入库时间
  已注册
  注册时间
  硬件版本
  软件版本
  采集协议
  设备数据推送地址
  传感器总数
  从站类
  无线信号值
  无线类型
  负责人
  联系方式
  编辑
  提交
  取消
  拆除
  请输入关键字
  搜索地址
  保存位置
  区域机构
  看一级区域机构里有没有已填写的安装区域，没有则先
  请选择有效的安装区域！
  重置
  去掉children
  null的属性
  点击弹框
  选择位置
  初始化地图
  缩放条
  异步加载插件
  地图定位到选中项位置
  创建标注
  将标注添加到地图中
  详情
  根据坐标显示设备定位address
  result为对应的地理位置详细信息
  创建标注
  将标注添加到地图中
  此操作将修改设备信息, 是否继续
  提示
  确定
  取消
  已取消修改
  此操作将拆除设备, 是否继续
  提示
  确定
  取消
  已取消拆除
  请您先选择地理位置
  创建标注
  将标注添加到地图中
  转化前
  转化后
  创建标注
  将标注添加到地图中
  创建标注
  将标注添加到地图中
  基本信息
  子设备名称
  子设备ID
  类型名称
  设备编码
  报警状态
  报警中
  正常
  故障状态
  故障
  完好
  是否删除
  否
  是
  是否在线
  离线
  在线
  安装位置
  安装经纬度
  创建时间
  数据最新时间
  无
  状态
  值
  编辑
  提交
  取消
  拆卸
  搜索地址
  搜索
  地图容器 
  保存位置
  地图定位到选中项位置
  创建标注
  将标注添加到地图中
  详情
  此操作将修改设备信息, 是否继续
  提示
  确定
  取消
  修改成功！
  已取消修改
  此操作将拆卸设备, 是否继续
  提示
  确定
  取消
  已取消拆卸
  请您先选择地理位置
  创建标注
  将标注添加到地图中
  转化前
  转化后
  创建标注
  将标注添加到地图中
  创建标注
  将标注添加到地图中
  全选
  全选
  删除
  设置表格最大高度
  设置表格最大高度
  是否显示加载中
  表格数据
  可选的pageSizes
  需要展示的page的控件的数组
  表格行的类名
  表格表头的类名
  存放选中值的数组
  pageSize变化时函数
  当前页变化时函数
  多选框的选项变化是触发函数
  选中的值
  全选
  请先勾选删除内容！
  此操作将永久删除内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  右边阴影
  离线
  报警中
  在线
  正常
  在线
  安装位置
  无
  离线
  报警中
  子设备
  离线
  正常
  在线
  离线
  正常
  报警中
  甲烷
  氨气
  硫化氢
  一氧化碳
  温度
  湿度
  电压
  继电器
  甲烷
  氨气
  硫化氢
  一氧化碳
  温度
  湿度
  电压
  继电器
  无
  安装位置
  无
  更新时间
  拆除设备
  子设备历史数据
  是否删除
  是否故障
  是
  否
  取 消
  确 定
  此操作将永久删除该设备, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  实时数据
  关闭实时更新
  开启实时更新
  暂无数据
  历史数据
  列表展示
  曲线展示
  至
  开始日期
  结束日期
  请输入字段名称
  查询
  最新数据更新时间
  暂无
  序号
  设备属性名称
  值
  更新时间
  暂无数据
  选择日期
  查询
  禁止选择本日之后
  一天
  一周
  一个月
  处的颜色
  处的颜色
  处的颜色
  缺省为 false
  日期
  坐标轴轴线相关设置
  数学上的x轴
  坐标轴刻度标签的相关设置
  报警次数
  最大值
  最小值
  最近一周
  最近一个月
  设备实时数据
  甲烷
  氨气
  硫化氢
  一氧化碳
  温度
  湿度
  电压
  继电器
  请您选择日期！
  查询
  查询
  表格展示条数变化时
  输入开始日期年份大于当前年份，请重新输入！
  输入结束日期年份大于当前年份，请重新输入！
  选择时间小于系统开始时间，请重新输入！
  查询月份的报警分表不存在
  请选择开始日期和结束日期！
  查询月份的报警分表不存在
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  历史曲线
  没有找到您要查询的相关数据
  没有找到您要查询的相关数据
  没有找到您要查询的相关数据
  请您选择日期！
  此操作将开启实时更新, 是否继续
  提示
  确定
  取消
  已取消
  此操作将关闭实时更新, 是否继续
  提示
  确定
  取消
  已取消
  调取接口获取数据
  四周阴影
  四周阴影
  修改高度
  左右箭头的样式
  实时统计
  更新数据
  收起统计
  历史报警走势
  最新报警记录
  序号
  设备名称
  设备IMEI
  报警内容
  安装位置
  报警时间
  暂无数据
  处的颜色
  处的颜色
  处的颜色
  缺省为 false
  日期
  坐标轴轴线相关设置
  数学上的x轴
  坐标轴刻度标签的相关设置
  报警次数
  最大值
  最小值
  没有找到您要查询的相关数据
  鼠标悬停停止滚动
  向下
  上滚动
  滚动速度
  滚动单行
  单行停顿时间
  获取当天履职列表
  在线设备
  设备总数
  今日新增
  今日报警
  今日故障
  历史报警走势
  没有找到您要查询的相关数据
  没有找到您要查询的相关数据
  没有找到您要查询的相关数据
  获取最新报警
  至
  开始日期
  结束日期
  故障状态
  请输入故障内容
  查询
  状态
  设备名称
  设备安装位置
  故障内容
  故障时间
  最近一周
  最近一个月
  传感器故障
  传感器故障
  KBG内部通讯错误
  KBG内部通讯错误
  无线模块通信错误
  无线模块通信错误
  设备未知异常
  设备未知异常
  查询
  查询
  表格展示条数变化时
  此操作将处理故障, 是否继续
  提示
  确定
  取消
  已取消处理
  版权 获取当前年
  输入开始日期年份大于当前年份，请重新输入！
  输入结束日期年份大于当前年份，请重新输入！
  选择时间小于系统开始时间，请重新输入！
  查询月份的报警分表不存在
  请选择开始日期和结束日期！
  查询月份的报警分表不存在
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  设备列表
  子设备列表
  设备列表
  子设备列表
  安装位置
  在线状态
  离线
  在线
  报警状态
  正常
  报警中
  是否故障
  完好
  故障
  搜索
  实时统计
  暂无数据
  在线
  离线
  基本信息
  设备数据
  报警记录
  故障记录
  节点点击发生变化时，触发事件
  查询
  搜索
  基本信息
  动态获取中间滚动高度,
  为头部和尾部的高度之和makeheightCons
  处理方式
  撤销
  处理人员
  撤销
  处理时间
  撤销
  处理意见
  请输入内容
  处理方式
  请选择处理类型
  处理意见
  请输入内容
  提交
  至
  开始日期
  结束日期
  按故障内容查询
  已处理
  未处理
  查询
  报表导出
  故障时间
  故障内容
  故障类型
  设备编码
  设备名称
  设备类型
  安装位置
  所在地址
  处理状态
  已处理
  已处理
  未处理
  处理状态
  未处理
  未处理
  已处理
  注册局部过滤器
  暂无时间
  为表格内取到的后台时间
  处理类型
  时间段
  单选框
  未处理
  处理
  对话框的表单
  已处理
  查看
  查询的数据
  表格数据
  按内容查询
  初始化表格数据
  处理类型
  表格数据获取失败
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  处理故障
  故障处理
  编辑设备
  查看处理
  处理信息
  获取数据列表失败
  提交故障处理
  处理成功
  取消
  报表导出
  查询
  搜索
  关闭抽屉
  表格当前页变化时
  表格展示条数变化时
  多选
  故障处理
  区域
  至
  开始日期
  结束日期
  处理进度
  请输入故障内容
  搜索
  报表导出
  设备名称
  设备ID
  设备IMEI
  设备种类
  设备注册至
  祥云
  联通
  设备安装位置
  故障时间
  故障内容
  处理状态
  已处理
  未处理
  通知记录
  查看
  操作
  处理
  最近一周
  最近一个月
  未处理
  已处理
  查询组织
  查询区域
  查询区域
  区域机构
  默认展开第一层根节点
  节点渲染完成后，加载第二层节点的核心代码
  区域
  终端出库设备
  终端出库设备
  终端出库设备
  节点点击发生变化时，触发事件
  查询
  搜索
  表格当前页变化时
  表格展示条数变化时
  此操作将处理故障, 是否继续
  提示
  确定
  取消
  已取消处理
  版权 获取当前年
  输入开始日期年份大于当前年份，请重新输入！
  输入结束日期年份大于当前年份，请重新输入！
  选择时间小于系统开始时间，请重新输入！
  查询月份的报警分表不存在
  查询月份的报警分表不存在
  查询月份的报警分表不存在
  通知记录
  关闭抽屉
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  此操作将导出报表, 是否继续
  提示
  确定
  取消
  导出成功
  已取消导出
  此操作将处理故障, 是否继续
  提示
  确定
  取消
  故障处理
  已取消处理
  处理详情
  新增隐患
  是否注册
  隐患标题
  隐患描述
  查询
  批量删除
  上报隐患
  报表导出
  隐患标题
  隐患位置
  隐患描述
  处理状态
  未处理
  已处理
  隐患现场图片
  风险等级
  低风险
  中风险
  高风险
  未知
  上报时间
  上报人
  操作
  处理
  详情
  删除
  隐患处理
  隐患处理详情
  新增隐患
  注册局部过滤器
  暂无时间
  为表格内取到的后台时间
  全部
  未处理
  已处理
  图片放大
  处理隐患
  处理隐患
  此操作将暂缓处理隐患, 是否继续
  提示
  确定
  取消
  暂缓处理隐患成功!
  已取消暂缓处理隐患
  删除
  此操作将永久删除该内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  详情
  关闭抽屉
  确认
  取消
  查询
  搜索
  多选
  批量删除
  请先勾选删除内容！
  此操作将永久删除内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  报表导出
  此操作将导出报表, 是否继续
  提示
  确定
  取消
  导出成功
  已取消导出
  没有进行条件筛选将导出全部数据，如果数据量过大请耐心等待，是否继续
  提示
  确定
  取消
  表格当前页变化时
  表格展示条数变化时
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  至
  开始日期
  结束日期
  隐患标题
  隐患内容
  搜索
  批量删除
  序号
  隐患标题
  处理内容
  处理图片
  处理人
  处理时间
  操作
  删除
  暂无数据
  图片放大
  查询租户功能
  刷新数据
  获取完整的年份
  位,1970
  获取当前月份
  代表1月
  获取当前日
  星期天
  星期一
  星期二
  星期三
  星期四
  星期五
  星期六
  获取当前星期X
  代表星期天
  获取当前小时数
  获取当前分钟数
  获取当前秒数
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  多选
  删除
  此操作将永久删除该内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  批量删除
  请先勾选删除内容！
  此操作将永久删除内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  全屏
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  基于自主研发传感技术行业应用的物联网平台
  基于自主研发传感技术行业应用的物联网平台
  沪ICP备18020687号
  版权所有
  河南省汉威智慧消防科技有限公司 技术热线
  沪ICP备18020687号
  星星闪动动画
  基于自主研发传感技术行业应用的物联网平台
  版权所有
  河南省汉威智慧消防科技有限公司 技术热线
  沪ICP备18020687号
  登录页canvas背景
  当窗口大小改变时
  星星之间的连线
  鼠标与星星之间的连线
  生成范围在min
  max之间的随机数
  请选择日志类型
  至
  开始日期
  结束日期
  请输入操作内容
  请输入操作IP地址
  搜索
  清空一个月前记录
  操作类型
  增加
  删除
  修改
  其他
  操作内容
  是否租户操作
  是
  否
  操作人
  ip地址
  操作时间
  暂无数据
  增加
  删除
  修改
  其他
  查询租户功能
  刷新数据
  获取完整的年份
  位,1970
  获取当前月份
  代表1月
  获取当前日
  星期天
  星期一
  星期二
  星期三
  星期四
  星期五
  星期六
  获取当前星期X
  代表星期天
  获取当前小时数
  获取当前分钟数
  获取当前秒数
  此操作将删除一个月之前的所有日志, 是否继续
  提示
  确定
  取消
  日志删除成功
  删除失败，
  已取消删除
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  设备类型
  报警区域
  巡检计划状态
  至
  至
  开始日期
  结束日期
  查询
  序号
  巡检计划名称
  巡检时间段
  至今
  至
  巡检状态
  进行中
  已结束
  巡检员
  巡检单操作
  查看
  本月
  今年至今
  最近六个月
  进行中
  已结束
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  查询
  搜索
  请选择正确的时间段进行查询！
  表格当前页变化时
  表格展示条数变化时
  查看
  关闭
  请选择
  请输入
  查询
  新增巡检项
  序号
  巡检设备类型
  巡检项名称
  巡检内容
  编辑
  删除
  巡检设备类型
  巡检项标题
  巡检内容
  选择行的模板名
  内容
  查询
  表格当前页变化时
  表格展示条数变化时
  新增
  新增巡检项
  新增巡检项
  编辑
  编辑巡检项
  编辑巡检项
  删除
  此操作将永久删除该巡检项, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  关闭抽屉
  确认
  保存页面巡检项信息
  添加成功
  添加失败
  修改页面巡检项信息
  修改成功
  修改失败
  取消
  巡检设备类型
  巡检项标题
  巡检内容
  内容
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  日历详情
  巡检计划状态
  至
  开始日期
  结束日期
  至
  开始日期
  结束日期
  请输入巡检计划名称
  查询
  新增巡检计划
  日历详情
  序号
  巡检模板名称
  巡检计划状态
  未开始
  进行中
  已结束
  巡检人
  巡检日期
  创建时间
  操作
  编辑
  删除
  未开始
  进行中
  已结束
  选择行的模板ID
  选择行的模板名
  查询
  请选择正确的日期范围
  表格当前页变化时
  表格展示条数变化时
  编辑
  编辑巡检计划
  编辑巡检计划
  删除
  此操作将永久删除该巡检计划, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  新增
  新增巡检计划
  新增巡检计划
  关闭抽屉
  确认
  保存页面巡检计划信息
  保存成功
  保存失败
  取消
  日历详情
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  请输入巡检点名称
  查询
  新增巡查点
  预览二维码
  序号
  巡检点名称
  巡检设备类型
  操作
  编辑
  删除
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  模糊查询
  巡检点名称
  巡查点列表
  查询
  搜索
  表格当前页变化时
  表格展示条数变化时
  编辑
  编辑巡查点
  编辑巡查点
  删除
  此操作将永久删除该内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  详情
  新增
  新增巡查点
  关闭抽屉
  确认
  保存页面巡检项信息
  添加成功
  保存页面巡检项信息
  编辑成功
  编辑失败
  取消
  二维码查看
  请先勾选巡查点！
  最多选择9项内容！
  多选
  至
  开始日期
  结束日期
  搜索
  不正常巡检设备类型排行
  共计
  单
  巡检员执行巡检计划数量排行表
  共计
  单
  不正常巡检设备占比
  最近一周
  最近一个月
  查询
  搜索
  输入开始日期年份大于当前年份，请重新输入！
  输入结束日期年份大于当前年份，请重新输入！
  选择时间小于系统开始时间，请重新输入！
  查询月份的报警分表不存在
  请选择开始日期和结束日期！
  查询月份的报警分表不存在
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  选择日期时间
  搜索
  日巡检异常数
  暂无数据
  至
  开始日期
  结束日期
  搜索
  月巡检异常数
  暂无数据
  坐标轴指示器，坐标轴触发有效
  默认为直线，可选为
  坐标轴指示器，坐标轴触发有效
  默认为直线，可选为
  最近一周
  最近一个月
  点
  查询
  搜索
  查询
  搜索
  根据日期统计异常数
  查询当天的异常数不存在
  根据月份统计异常数
  输入开始日期年份大于当前年份，请重新输入！
  输入结束日期年份大于当前年份，请重新输入！
  选择时间小于系统开始时间，请重新输入！
  查询月份的异常数不存在
  请选择开始日期和结束日期！
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  模板状态
  请输入巡检模板名称
  查询
  新增巡检模板
  序号
  模板名称
  状态
  生效中
  未生效
  巡检点
  巡检设备类型
  操作
  编辑
  删除
  下发
  暂停
  请选择
  未生效
  生效中
  选择行的模板ID
  选择行的模板名
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  查询
  表格当前页变化时
  表格展示条数变化时
  编辑
  编辑巡检模板
  编辑巡检模板
  删除
  此操作将永久删除该内容, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  下发
  下发巡检计划后将不能再修改, 是否继续
  暂停巡检计划，是否继续
  提示
  确定
  取消
  下发成功!
  暂停成功!
  已取消下发
  已取消暂停
  新增
  新增巡检模板
  新增巡检模板
  关闭抽屉
  确认
  保存页面巡检项信息
  添加成功
  保存页面巡检项信息
  编辑成功
  编辑失败
  巡检点已存在,请重新选择
  取消
  请选择
  请输入巡检类型名称
  查询
  新增巡检类型
  序号
  巡检类型名称
  是否为设备类型
  是
  否
  操作
  添加子项
  编辑
  删除
  选择行的类型ID
  选择行的类型名
  父级巡检类型
  子级巡检类型
  查询
  表格当前页变化时
  表格展示条数变化时
  新增
  新增巡检类型
  新增巡检类型
  添加子项
  新增子巡检类型
  新增子巡检类型
  编辑
  编辑巡检类型
  编辑巡检类型
  删除
  此操作将永久删除该巡检类型, 是否继续
  提示
  确定
  取消
  删除成功!
  已取消删除
  关闭抽屉
  确认
  保存页面巡检类型信息
  添加成功
  添加失败，
  修改成功
  修改失败
  取消
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  至
  查询
  序号
  自查开始时间
  自查结束时间
  自查项目总数
  自查项目异常数量
  自查内容数量
  自查内容异常数量
  自查条款数量
  自查条款异常数量
  其它问题
  无
  自查状态
  已完成
  进行中
  操作
  下载
  注册局部过滤器
  暂无时间
  为表格内取到的后台时间
  本月
  今年至今
  最近六个月
  表格当前页变化时
  表格展示条数变化时
  自查报表
  人员列表
  用户名
  请输入用户名
  姓名
  请输入姓名
  微信昵称
  请输入微信昵称
  搜索
  新增
  用户名
  姓名
  电话
  状态
  禁用
  正常
  锁定
  所属单位
  所属角色
  微信昵称
  微信头像
  从业资格证
  操作
  编辑
  删除
  查看
  解锁
  查看
  所属单位
  所属单位
  用户名
  请输入用户名
  姓名
  请输入姓名
  电话
  请输入电话
  是否重置密码
  重置
  不重置
  密码
  请输入密码
  确认密码
  请输入确认密码
  分配角色
  未选
  已选
  从业资格证
  提交中
  提交
  取 消
  关闭
  展示单个图片
  所属单位不能为空
  密码不能为空
  密码长度需要在1
  位之间
  确认密码长度需要在1
  位之间
  微信昵称
  用户登录名
  用户名
  编辑是记录用户原始头像
  用handler方法，导致this指向改变
  查询
  搜索
  启用账户
  解锁账户
  禁用账户
  锁定账户24小时
  此操作将
  是否继续
  提示
  确定
  取消
  成功
  失败
  添加用户
  请选择组织结构!
  请分配角色!
  添加成功!
  编辑成功!
  请您按照提示正确填写表单
  编辑修改
  编辑用户
  加载错误
  表格当前页变化时
  表格展示条数变化时
  此操作将永久删除该用户, 是否继续
  提示
  确定
  取消
  人员已删除!
  已取消删除
  账户解锁authId
  解锁成功！
  解锁失败，请联系管理员！
  查看
  查看用户
  加载错误
  图片放大
  树形结构
  去掉children
  null的属性
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  上传图标事件
  对上传图片的大小
  格式进行限制
  只支持jpeg或jpg或png格式图片
  请上传1MB以内的图片!
  用户名不能为空
  请输入正确的1
  位由
  数字组成的用户名！
  姓名不能为空
  请输入正确的1
  位由汉字组成的姓名！
  确认密码不能为空
  确认密码和密码不一致
  电话号码不能为空
  格式不合法,请输入正确的11位数字组成的联系方式！
  多选框
  角色名称
  角色描述
  是否系统角色
  是
  否
  是否启用
  启用
  禁用
  搜索
  新增
  名称
  角色描述
  是否内置角色
  是
  否
  是否启用
  启用
  禁用
  创建时间
  操作
  禁用
  启用
  编辑
  删除
  名称
  描述
  是否是系统角色
  否
  是
  未知
  操作
  编辑
  删除
  角色名称
  请输入角色名称
  角色描述
  请输入角色描述
  权限分配
  全选
  提交中
  提交
  取 消
  角色名称
  请输入角色名称
  角色描述
  请输入角色描述
  权限分配
  全选
  提交中
  提交
  取 消
  添加角色
  角色名不能为空
  编辑角色
  角色名不能为空
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  请按要求完善表单信息
  添加成功
  由于您当前属于该角色，编辑该角色的权限信息将导致您权限丢失
  找回丢失的权限需联系为您分配权限的人员
  警告
  继续
  取消
  等组件数据绑定完成
  等组件数据绑定完成
  请按要求完善表单信息
  修改成功
  由于您当前属于该角色，删除该角色将导致您权限丢失
  找回丢失的权限需联系为您分配权限的人员
  警告
  继续
  取消
  已取消删除
  确定要进行删除操作吗
  提示
  继续
  取消
  已取消删除
  删除成功
  操作成功
  操作成功
  区域类别
  负责人员
  区域名称
  搜索
  区域
  新增
  区域名称
  区域类别
  建筑结构
  火灾危险性
  耐火等级
  负责人员
  区域底图
  操作
  编辑
  删除
  未查询到区域类别
  回调负责人
  未查询到负责人列表
  查询
  搜索
  表格当前页变化时
  表格展示条数变化时
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  编辑
  编辑区域
  删除
  此操作将永久删除该区域, 是否继续
  提示
  确定
  取消
  删除成功!
  删除失败!
  已取消删除
  新增
  新增
  关闭抽屉
  确认
  取消
  图片放大
  请选择日志类型
  昵称
  登录名
  联系方式
  搜索
  添加
  清空一个月前记录
  租户昵称
  租户登录名
  联系方式
  邮箱地址
  创建时间
  是否启用
  正常
  禁用
  是否锁定
  已锁定
  未锁定
  锁定到期时间
  描述
  操作
  编辑
  修改密码
  禁用
  启用
  解锁
  锁定
  删除
  是否删除该租户
  是否修改密码
  请输入管理员密码
  请输入租户新密码
  请重新输入新密码
  取 消
  确 定
  表格
  表格
  添加编辑
  添加编辑
  修改密码删除
  两次密码输入不一致，请重新输入
  两次密码输入一致
  表格
  表格
  添加
  添加
  添加成功
  编辑成功
  添加
  编辑
  编辑
  添加
  修改密码
  管理员密码不能为空
  删除该租户成功
  输入的密码格式有误,请重新输入
  删除功能
  修改密码功能
  两次输入的结果不同，请重新输入
  租户新密码不能为空
  租户密码输入格式不正确,密码为6
  个字符
  修改密码错误，请联系管理员
  修改密码成功
  输入的密码格式有误,请重新输入
  请输入租户密码
  租户密码必须在6
  个字符之间
  已取消删除
  已取消修改密码
  此操作将删除该租户, 是否继续
  提示
  确定
  取消
  删除成功
  已取消操作
  修改密码
  禁用
  此操作将禁用该租户, 是否继续
  提示
  确定
  取消
  操作成功
  已取消操作
  禁用
  启用
  此操作将启用该租户, 是否继续
  提示
  确定
  取消
  操作成功
  已取消操作
  启用
  锁定
  此操作将锁定该租户, 是否继续
  提示
  确定
  取消
  操作成功
  已取消操作
  此操作将解锁该租户, 是否继续
  提示
  确定
  取消
  操作成功
  已取消操作
  锁定
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  请输入规则名称
  角色描述
  是否系统角色
  是
  否
  是否启用
  启用
  禁用
  搜索
  新增
  规则名称
  规则Key
  控制ID
  转发类型
  属性上报
  事件上报
  状态
  启用
  禁用
  创建时间
  转发路径
  操作
  查看
  编辑
  删除
  规则名称
  请输入规则名称
  规则Key
  请选择
  规则备注
  请输入规则备注
  数据类型
  请选择
  标签上报
  类型上报
  数据来源
  请选择
  请选择
  所有设备
  路径类型
  请选择
  为安全起见，HTTP路径类型的传送方法默认为POST
  转发路径
  请输入转发路径
  提交中
  提交
  取 消
  新增推送
  规则名称不能为空
  规则Key不能为空
  数据类型不能为空
  数据来源不能为空
  转发类型不能为空
  转发路径不能为空
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  请求数据列表
  新增数据
  新增推送
  编辑推送
  查看推送
  规则key下拉列表
  切换列表页数
  切换列表分页大小
  编辑
  提交
  成功！
  失败！请重新提交
  请按照要求填写正确信息！
  删除列表
  此操作将永久删除该条信息, 是否继续
  提示
  确定
  取消
  删除成功！
  删除失败！请重重试
  已取消删除
  是否启用
  操作成功！
  操作失败！
  预览
  首页背景选择
  地图
  地图
  卫星图
  卫星图
  首页面板配置
  请选择6项
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  请选择6项后重试
  添加成功
  确认
  取消
  请输入标签名称
  搜索
  新增
  标签名称
  标签Key
  创建时间
  操作
  查看
  编辑
  删除
  标签名称
  请输入标签名称
  标签Key
  请输入标签Key
  编辑标签
  标签备注
  请输入标签备注
  提交中
  提交
  取 消
  标签Key不能为纯数字！
  标签Key必须有字母和数字组成！
  新增推送
  标签名称不能为空
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  请求数据列表
  新增数据
  新增推送
  编辑标签
  查看标签
  切换列表页数
  切换列表分页大小
  编辑
  提交
  成功！
  失败！请重新提交
  请按照要求填写正确信息！
  删除列表
  此操作将永久删除该条信息, 是否继续
  提示
  确定
  取消
  删除成功！
  删除失败！请重重试
  已取消删除
  组织
  维护
  添加根组织
  完成
  终端用户
  终端用户不让修改
  终端用户
  终端用户
  终端用户不让修改 
  终端用户
  用户列表
  请输入昵称
  请输入邮箱地址
  请输入联系方式
  请选择角色
  是否启用
  启用
  禁用
  搜索
  添加用户
  添加用户
  昵称
  邮箱地址
  联系方式
  是否启用
  启用
  禁用
  登录名
  账户状态
  锁定
  正常
  解锁时间
  所属组织
  创建时间
  操作
  终端用户
  终端用户
  编辑
  终端用户
  终端用户
  解锁
  终端用户
  终端用户
  锁定
  终端用户
  终端用户
  禁用
  终端用户
  终端用户
  启用
  终端用户
  终端用户
  删除
  暂无数据
  组织维护
  组织维护
  组织名称
  请输入组织名称
  序号
  序号
  添加
  编辑
  重置
  取消
  添加
  编辑
  重置
  取 消
  添加用户
  添加用户
  用户昵称
  请输入用户昵称
  用户手机号
  请输入用户手机号
  用户手机号
  请输入手机号
  组织机构
  请选择组织机构
  请选择组织机构
  用户邮箱
  请输入用户邮箱
  是否可登录
  可登录
  不可登录
  用户登录名
  请输入用户登录名
  用户密码
  请输入用户密码
  负责区域
  负责人角色
  请选择
  安装区域
  安装员角色
  请选择
  请为用户分配角色
  未选
  已选
  添 加
  添加
  重置
  取 消
  编辑用户
  编辑用户
  用户昵称
  请输用户昵称
  用户手机号
  请输入手机号
  请输入用户手机号
  组织机构
  请选择区域
  请选择组织机构
  用户邮箱
  请输入用户邮箱
  是否可登录
  可登录
  不可登录
  用户登录名
  请输入用户登录名
  用户登录名长度在 2 到 20 个字符
  用户登录名
  请输入用户登录名
  是否重设密码
  重设
  不重设
  用户密码
  请输入用户密码
  用户登录密码长度在 6 到 20 个字符
  请输入用户密码
  负责区域
  负责人角色
  请选择
  安装区域
  安装员角色
  请选择
  请为用户分配角色
  未选
  已选
  编 辑
  重置
  取 消
  编 辑
  邮箱地址不能为空
  您输入的邮箱地址格式不正确
  组织机构
  添加
  编辑
  请输入组织名称
  组织名称格式为中文
  字母
  数字组成
  组织名称长度在 1 到 15 个字符
  请输入组织代码
  组织代码长度在 1 到 30 个字符
  请输入用户昵称
  用户昵称长度在 1 到 20 个字符
  请添加手机号码
  请输入正确格式的手机号码
  请输入登录名
  登录名格式不正确，必须为字母
  数字组成
  登录名长度必须是2
  位
  请输入密码
  密码长度必须是1
  位
  请输入用户昵称
  用户昵称长度在 1 到 20 个字符
  请添加手机号码
  请输入正确格式的手机号码
  请输入登录名
  登录名格式不正确，必须为字母
  数字组成
  登录名长度必须是2
  位
  请输入密码
  密码长度必须是1
  位
  邮箱地址不能为空
  您输入的邮箱地址格式不正确
  请输入登录名
  登录名格式不正确，必须为字母
  数字组成
  登录名长度必须是2
  位
  查询组织
  组织机构
  默认展开第一层根节点
  节点渲染完成后，加载第二层节点的核心代码
  查询区域
  区域机构
  默认展开第一层根节点
  节点渲染完成后，加载第二层节点的核心代码
  编辑
  赋值
  设置勾选的值
  设置勾选的值
  终端用户
  安装员角色
  负责人角色
  元素值，元素的索引，原数组
  select框值改变时候触发的事件
  设置勾选的值
  select框值改变时候触发的事件
  设置勾选的值
  这里两个true，1
  是否只是叶子节点 2
  是否包含半选节点
  就是使得选择的时候不包含父节点
  这里两个true，1
  是否只是叶子节点 2
  是否包含半选节点
  就是使得选择的时候不包含父节点
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  查询组织
  设置选中
  此操作将锁定该用户, 是否继续
  提示
  确定
  取消
  锁定成功
  已取消锁定
  此操作将解锁该用户, 是否继续
  提示
  确定
  取消
  解锁成功
  已取消解锁
  此操作将禁用该用户, 是否继续
  提示
  确定
  取消
  禁用成功
  已取消禁用
  此操作将启用该用户, 是否继续
  提示
  确定
  取消
  启用成功
  已取消启用
  组织已添加!
  操作失败!
  表单验证失败!
  编辑成功!
  操作失败!
  表单验证失败!
  移除组织
  此操作将永久删除该组织, 是否继续
  提示
  确定
  取消
  组织已删除!
  删除失败!
  已取消删除
  节点点击发生变化时，触发事件
  终端用户
  查询此组织不存在，编辑失败!
  重置表单值
  请先选择组织机构
  请选择组织机构!
  添加成功!
  添加用户表单参数校验失败!!
  校验组织字段是否为组织机构
  设置勾选的值
  设置勾选的值
  加载错误!
  请选择组织机构!
  编辑成功!
  编辑用户表单参数校验失败!!
  此操作将删除此用户, 是否继续
  提示
  确定
  取消
  用户已删除!
  删除失败，
  已取消删除
  树形结构
  去掉children
  null的属性
  终端用户
  动态删除编辑里的电话
  电话
  固话  
  手机号不能为空！
  手机号校验
  手机号位数为11位！
  手机号格式不正确！
  号码格式不正确！
  请填写正确号码！
  如
  位手机号或固话
  区号
  号码
  切换组织机构
  表示选择了
  终端用户
  终端用户
  邮箱校验
  是终端用户时校验不同
  终端用户
  用户登录名校验
  是终端用户时校验不同
  格式错误，组织为
  终端用户
  时，用户登录名为11位手机号
  终端用户
  终端用户
  区域
  维护
  添加根组织
  完成
  终端用户
  终端用户不让修改 
  终端用户
  终端用户不让修改
  用户列表
  请输入昵称
  电话
  人员类型
  负责人
  安装人
  搜索
  绑定区域与用户关系
  昵称
  区域名称
  联系方式
  是否启用
  启用
  禁用
  人员类型
  负责人
  安装人
  更新时间
  操作
  解除区域关系
  区域维护
  区域名称
  请输入区域名称
  序号
  序号
  是否为社区
  是
  否
  添加
  编辑
  重置
  取 消
  添加编辑
  请输入区域名称
  区域名称格式为中文
  字母
  数字组成
  区域名称长度在 1 到 15 个字符
  请输入序号
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  查询组织
  设置选中
  查询区域
  区域机构
  默认展开第一层根节点
  节点渲染完成后，加载第二层节点的核心代码
  区域已添加!
  操作失败!
  表单验证失败!
  编辑成功!
  操作失败!
  表单验证失败!
  移除区域
  此操作将永久删除该区域, 是否继续
  提示
  确定
  取消
  区域已删除!
  删除失败!
  已取消删除
  节点点击发生变化时，触发事件
  添加区域
  编辑区域
  重置表单值
  此操作将解除区域和用户关系, 是否继续
  提示
  确定
  取消
  关系已解除!
  解除失败，
  已取消
  添加
  绑定区域与用户关系
  绑定关系成功
  系统设置
  文本框
  复选框 
  单选框 
  logo图片上传 
  LOGO上传
  注
  请上传50 
  像素
  大小不超过100KB的图片
  LOGO上传
  注
  请上传50 
  像素
  大小不超过100KB的图片
  保存
  省市选择 
  系统名称长度不能大于13位
  系统名称长度不能小于1位
  请上传图片！
  系统配置信息修改成功!
  地址转file对象
  省市
  全
  全
  全
  中国
  图片上传成功钩子
  接口返回的数据
  文件对象
  上传logo的校验
  文件对象
  格式校验
  只支持jpeg或jpg或png格式图片
  大小校验
  请上传100KB以内的图片!
  宽高校验
  上传的图片宽高必须是50
  图片上传成功
  最多添加三张轮播图
  添加
  显示序号
  名称
  图片
  添加时间
  操作
  编辑
  删除
  添加图片
  编辑图片
  添加
  编辑
  关闭抽屉
  删除
  确认删除这些数据吗
  删除提示
  确定
  取消
  删除成功
  已取消删除
  删除
  微信公众号配置
  微信认证文件
  请上传微信认证文件
  只能上传txt文件，例如
  点击上传
  点击上传
  只能上传txt文件，例如
  请输入公众号appId
  请输入公众号appsecret
  报警模板ID
  请输入报警模板ID
  故障模板ID
  请输入故障模板ID
  微信回调URL
  保存配置
  服务地址
  操作成功
  上传文件只能是 TXT 格式!
  上传文件大小不能超过 2KB!
  上传成功
  只能上传一个文件
  新增
  单位名称
  所属行业
  消防级别
  消防安全责任人
  专职消防人
  建筑面积
  消防车道数
  消防电梯数
  避难层位置
  公司图片
  操作
  编辑
  删除
  查看
  搜索地址
  搜索
  地图容器 
  保存位置
  关闭抽屉
  新增单位信息
  定位到当前位置
  创建标注
  将标注添加到地图中
  表格当前页变化时
  表格展示条数变化时
  动态获取中间滚动高度,
  为头部和尾部的高度之和
  编辑
  编辑单位信息
  地图定位到选中项位置
  创建标注
  将标注添加到地图中
  删除
  此操作将永久删除该单位以及子单位信息, 是否继续
  提示
  确定
  取消
  删除成功!
  删除失败!
  已取消删除
  确认
  取消
  图片放大
  转化前
  转化后
  创建标注
  将标注添加到地图中
  创建标注
  将标注添加到地图中
  为合理
  规范化使用平台，建议用户按照以下流程图所示步骤进行设置使用，其中登录平台
  角色管理
  建立组织
  添加用户
  新建区域
  绑定区域与用户关系
  平台查看这些步骤是由租户来操作完成，扫码安装由用户或者安装人员来完成
  在操作之前首先解释下角色
  用户
  组织
  租户
  子租户
  区域的概念和关系
  角色
  角色是可执行一系列特定操作的用户特性，角色规定了用户一系列权利和特权
  用户
  用户就是一个有身份验证信息的API消费实体，用户默认属于组织
  组织
  组织就是多用户的集合
  租户
  租户其实是各个服务中的一些可访问的资源集合，这些资源集合可供多个组织
  用户使用，且各租户之间相互独立
  子租户
  子租户和租户有着相同的属性，是租户的下一层级，归租户来管理
  区域
  区域是带有地理位置属性的，用户需要与区域绑定在一起使用
  登录界面
  通过提供的
  账号
  和
  密码
  填入输入框点击
  登录
  星图平台的登录网址为
  登录后跳出下图所示的平台展示界面，点击
  后台
  进入系统配置界面
  角色管理
  单击
  系统管理
  在下拉菜单中选择
  角色管理
  系统已经自动创建好角色并为角色分配好相应的权限
  创建角色的目的是对用户进行角色权限的分配，点击右侧的
  编辑
  按钮可查看角色的相应权限
  负责人角色
  负责所有设备的查询
  报警历史和故障历史的管理
  管理员角色
  具有平台分配的所有权限
  用户角色
  设备的安装
  报警历史和故障历史的查询
  安装员角色
  设备总览
  查询和安装设备
  报警历史和故障历史的管理
  巡检员角色
  目前没有任何权限
  建立组织
  单击
  系统管理
  在下拉菜单中选择
  组织管理
  点击
  维护
  进入组织添加
  点击
  组织机构
  右侧的
  号进入新建组织
  输入组织名称点击下方的添加按钮即可完成添加
  建区域
  单击
  系统管理
  在下拉菜单中选择
  区域管理
  点击
  维护
  进入添加区域
  点击
  区域机构
  右侧的
  号进入新建区域
  输入区域名称点击下方的添加按钮即可完成添加
  添加用户
  单击
  系统管理
  在下拉菜单中选择
  组织管理
  随即点击添加用户
  弹出下图所示界面后按要求进行填写，完成后点击下方
  添加
  即可
  选择相应的组织机构
  选择是否可登录，是的话可以以分配的角色身份来登录平台
  建立一个用于登录的账户
  给用户分配相应权限的角色，在左侧方框中选中角色点击
  移到右侧方框
  绑定区域与用户关系
  单击
  系统管理
  在下拉菜单中选择
  区域管理
  随后点击绑定区域与用户关系按钮进行绑定
  选择区域
  对应相应负责人或安装人员点击提交即可
  负责人列表
  指具有负责人角色的人员列表     安装人列表
  指具有安装人角色的人员列表
  扫码安装
  微信搜公众号
  智慧星图物联网平台，点击关注后跳出如下图所示界面
  点击下方
  星图物联
  进入下图所示界面，使用微信账号登录，需要先绑定好手机号码，填写正确的验证码绑定完成后会弹出设置登录密码的界面，设置完登录密码点击提交即可
  登录成功后显示下图所示界面
  点击添加设备，跳出下图所示界面，扫描设备二维码，自动跳出设备编号，输入具体安装位置，然后选择好安装区域点击保存，出现安装成功提示界面即可
  平台查看
  再次登录星图平台在相应的设备栏下查看已经安装的设备
*/